import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaEraser, FaSave, FaFileMedicalAlt } from "react-icons/fa";
import Swal from "sweetalert2";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Cookies from "js-cookie";
import api from "../../config/configApi";
import { Stethoscope, FolderOpen, NotebookPen, ChevronRight } from "lucide-react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Menu from "../../components/MenuProntuario";
import Footer from "../../components/FooterPagina";
import { MousePointerClick } from "lucide-react";
import { FileText } from "lucide-react";
import GuiaSADTSalvas from "../../components/GuiaSPESADTSalvas";
import DocumentosHandler from "../../components/DocumentosHandler/DocumentosHandler";
import GroupedProfessionalsAccordion from "../../components/GroupedProfessionalsAccordion";
import odPng from "../../images/Direito.png";
import oePng from "../../images/Esquerdo.png";
import rodape from "../../images/rodape.png";
import Logo from "../../images/logopdf.png";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import WatermarkLogo from "../../assets/afrafep.png";
import ModalVisualizacao from "../../components/ModalVisualizacao.tsx";
import ProntuarioAnexos from "../../components/ProntuarioAnexos";
import { agruparPorEspecialidade } from "../../utils/agrupamentoProntuarios";
import { buscarEspecialidadesProfissionais } from "../../utils/profissionaisEspecialidade";

interface ReceituarioLaudo {
  id: number;
  tipo: string;
  dtConsulta: string;
  hrConsulta: string;
  cid: string;
  atestadoQtdDias: number;
  prescricao: string;
  criadoEm: string;
  editadoEm: string;

  // ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½Y"ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ Campos de Longe (OD/OE)
  odEsfLong: number | null;
  odCilLong: number | null;
  odEixoLong: number | null;
  odPrismaLong: number | null;
  odBaseLong: number | null;

  oeEsfLong: number | null;
  oeCilLong: number | null;
  oeEixoLong: number | null;
  oePrismaLong: number | null;
  oeBaseLong: number | null;

  // ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½Y"ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ Campos de Perto (OD/OE)
  odEsfPerto: number | null;
  odCilPerto: number | null;
  odEixoPerto: number | null;
  odPrismaPerto: number | null;
  odBasePerto: number | null;

  oeEsfPerto: number | null;
  oeCilPerto: number | null;
  oeEixoPerto: number | null;
  oePrismaPerto: number | null;
  oeBasePerto: number | null;

  profissional: {
    idProfissional: number;
    nmProfissional: string;
    CRM?: string;

    especialidade: {
      idEspecialidade?: number;
      dsEspecialidade: string;
      exibeQuestEpidem?: string;
      realizaProced?: string;
    };
  };

  paciente: {
    cdPaciente: number;
    nrCarteiraPlano: string;
    nmPaciente: string;
    dtNascimento: string;
    flSexo: string;
    cdStatus: number;
    nuCpf: string;
    nmEndereco: string;
    nuEndereco: number;
    nmComplEndereco: string;
    nmBairroEndereco: string;
    nmCidadeEndereco: string;
    nmUfEndereco: string;
    cdCepEndereco: string;
    cartaoSus: string;
  };
}

interface Evolucao {
  idEvolucao: number;
  cdPaciente: number;
  nuCpf: string;
  dtHraEvolucao: string;
  tipo: string;
  idProfissional: number;
  dsEvolucao: string;
  profissional: {
    idProfissional: number;
    nmProfissional: string;
    especialidade: {
      idEspecialidade: number;
      dsEspecialidade: string;
    };
  };
  dtHraAlteracao: string;
  cdMedicoAlteracao: number | null;
  localEvolucao: string;
  maisSaude: string | null;
}

interface Profissional {
  id: number;
  nome: string;
  CRM?: string;
}

interface Especialidade {
  idEspecialidade: number;
  dsEspecialidade: string;
}

interface Paciente {
  cdPaciente: number;
  nmPaciente: string;
  flSexo: string;
  dtNascimento: string;
}

interface Ciclo {
  id: number;
  paciente: Paciente;
  especialidade: Especialidade;
  dtInicio: string;
  dtFim: string;
  status: string;
  dtCadastro: string;
  dtAlteracao: string | null;
}

interface ReceituarioGrupo {
  especialidade: string;
  profissionais: {
    idProfissional: number;
    nome: string;
    items: ReceituarioLaudo[];
  }[];
}

interface EspecialidadeComPermissoes {
  idEspecialidade: number;
  dsEspecialidade: string;
  ativo: boolean;
  ativaAgendaOnlineSn: string;
  atendeMenorIdade: string;
  exibeQuestEpidem: string;
  realizaProced: string;
  cboTuss: string;
  guiaSadt: boolean;
  receituarioComum: boolean;
  receituarioEspecial: boolean;
  atestado: boolean;
  laudo: boolean;
  oftalmo: boolean | null;
  altaFisio: boolean | null;
}

const AtendimentoPrincipal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentPages, setCurrentPages] = useState<Record<number, number>>({});

  const [especialidadeAtual, setEspecialidadeAtual] =
    useState<EspecialidadeComPermissoes | null>(null);

  useEffect(() => {
    const fetchEspecialidadeAtual = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const idEspecialidade = Cookies.get("idEspecialidade");

        if (token && idEspecialidade) {
          const response = await api.get(`/sisclinic/especialidades/${idEspecialidade}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setEspecialidadeAtual(response.data);
        }
      } catch (error) {
        console.error("Erro ao buscar dados da especialidade:", error);
      }
    };

    fetchEspecialidadeAtual();
  }, []);

  const [receituariosLaudos, setReceituariosLaudos] = useState<
    ReceituarioLaudo[]
  >([]);
  const [loadingReceituarios, setLoadingReceituarios] = useState(true);

  const nome = Cookies.get("Nome");
  const idade = Cookies.get("idade");
  const flPms = Cookies.get("flPms");


  const [prontuarioIndexAberto, setProntuarioIndexAberto] = useState<
    number | null
  >(null);
  const [prontuarioAtual, setProntuarioAtual] = useState<string>("");
  const [prontuarioAtualId, setProntuarioAtualId] = useState<number | null>(
    null,
  );
  const [prontuarioAnexosId, setProntuarioAnexosId] = useState<number | null>(
    null,
  );
  const [anexosRefreshKey, setAnexosRefreshKey] = useState(0);
  const [salvando, setSalvando] = useState<boolean>(false);
  const [, setProfissionais] = useState<Profissional[]>([]);
  const [meusAtendimentos, setMeusAtendimentos] = useState<Evolucao[]>([]);
  const [outrosProfissionais, setOutrosProfissionais] = useState<Evolucao[]>(
    []
  );
  const { idEvent, cdPaciente, idProfissional } = location.state || {};
  const [evolucaoEditando, setEvolucaoEditando] = useState<Evolucao | null>(
    null
  );

  const [expandedEspecialidades, setExpandedEspecialidades] = useState<
    string[]
  >([]);
  const [, setEspecialidades] = useState<any[]>([]);

  const [modoEdicao, setModoEdicao] = useState(false);
  const [loadingMeus, setLoadingMeus] = useState(true);
  const [loadingOutros, setLoadingOutros] = useState(true);

  const itemsPerPage = 4;

  const [modalAberto, setModalAberto] = useState(false);
  const [, setShowButtons] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [, setCiclos] = useState<Ciclo[]>([]);

 
  const [paginaAtual, setPaginaAtual] = useState(1);
  const itensPorPagina = 7;

  const totalPaginas = Math.ceil(meusAtendimentos.length / itensPorPagina);

  const mudarPagina = (novaPagina: number) => {
    if (novaPagina >= 1 && novaPagina <= totalPaginas) {
      setPaginaAtual(novaPagina);
      setProntuarioIndexAberto(null);
    }
  };

  const [activeTab, setActiveTab] = useState<
    "meus" | "outros" | "sadt" | "receituarios" | "altas" | null
  >("meus");
  const [outrosCurrentPages, setOutrosCurrentPages] = useState<
    Record<string, number>
  >({});
  const outrosItensPorPagina = 10;

  const fetchReceituariosLaudos = useCallback(async () => {
    const cpf = Cookies.get("NuCPF");
    const token = sessionStorage.getItem("token");

    if (cpf && token) {
      try {
        setLoadingReceituarios(true);
        const response = await api.get<ReceituarioLaudo[]>(
          `/sisclinic/receituarios/cpf/${cpf}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const receituariosOrdenados = response.data.sort((a, b) => {
          const dateA = new Date(`${a.dtConsulta}T${a.hrConsulta}`);
          const dateB = new Date(`${b.dtConsulta}T${b.hrConsulta}`);
          return dateB.getTime() - dateA.getTime();
        });

        setReceituariosLaudos(receituariosOrdenados);
      } catch (error) {
        console.error("Erro ao buscar Receituarios e laudos:", error);
      } finally {
        setLoadingReceituarios(false);
      }
    }
  }, []);

  const formatDate = (dateString?: string) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("pt-BR");
  };

  const diasPorExtenso = (dias: number) => {
    const unidades = [
      "zero",
      "um",
      "dois",
      "três",
      "quatro",
      "cinco",
      "seis",
      "sete",
      "oito",
      "nove",
    ];
    const dezes = [
      "dez",
      "onze",
      "doze",
      "treze",
      "quatorze",
      "quinze",
      "dezesseis",
      "dezessete",
      "dezoito",
      "dezenove",
    ];
    const dezenas = [
      "vinte",
      "trinta",
      "quarenta",
      "cinquenta",
      "sessenta",
      "setenta",
      "oitenta",
      "noventa",
    ];

    if (dias < 10) return unidades[dias];
    if (dias < 20) return dezes[dias - 10];
    if (dias < 100) {
      const dezena = Math.floor(dias / 10);
      const resto = dias % 10;
      return dezenas[dezena - 2] + (resto !== 0 ? ` e ${unidades[resto]}` : "");
    }
    return dias.toString();
  };

  const [expandedProfissionais, setExpandedProfissionais] = useState<number[]>(
    [],
  );
  const [gruposAltas, setGruposAltas] = useState<ReceituarioGrupo[]>([]);
  const [loadingGruposAltas, setLoadingGruposAltas] = useState(true);
  const [grupos, setGrupos] = useState<ReceituarioGrupo[]>([]);
  const [loadingGrupos, setLoadingGrupos] = useState(true);

  useEffect(() => {
    const loadGrupos = async () => {
      if (receituariosLaudos.length === 0) {
        setGrupos([]);
        setGruposAltas([]);
        setLoadingGrupos(false);
        setLoadingGruposAltas(false);
        return;
      }

      const token = sessionStorage.getItem("token");
      const [gruposData, gruposAltasData] = await Promise.all([
        agruparPorEspecialidade(
          receituariosLaudos,
          (item) => item.tipo !== "ALTA_FISIO",
          token,
        ),
        agruparPorEspecialidade(
          receituariosLaudos,
          (item) => item.tipo === "ALTA_FISIO",
          token,
        ),
      ]);

      setGrupos(gruposData);
      setGruposAltas(gruposAltasData);
      setLoadingGrupos(false);
      setLoadingGruposAltas(false);
    };

    setLoadingGrupos(true);
    setLoadingGruposAltas(true);
    loadGrupos();
  }, [receituariosLaudos]);

  useEffect(() => {
    fetchReceituariosLaudos();
  }, [fetchReceituariosLaudos]);  const toggleEspecialidade = (especialidade: string) => {
    setExpandedEspecialidades((prev) =>
      prev.includes(especialidade)
        ? prev.filter((e) => e !== especialidade)
        : [especialidade]
    );
  };

  const toggleProfissional = (
    idProfissional: number,
    _especialidade?: string,
  ) => {
    setExpandedProfissionais((prev) =>
      prev.includes(idProfissional)
        ? prev.filter((id) => id !== idProfissional)
        : [idProfissional]
    );
  };

  const renderReceituarioLaudo = (item: ReceituarioLaudo) => {
    const [ano, mes, dia] = item.dtConsulta.split("-");
    const dataFormatada = `${dia}/${mes}/${ano}`;

    return (
      <div
        key={item.id}
        onClick={() => visualizarReceituarioLaudo(item)}
        className="mb-2 p-2 border rounded-lg bg-gray-50 shadow-sm hover:shadow transition cursor-pointer text-xs"
      >
        <div className="flex items-center justify-between">
          <span className="text-gray-800">
            <span className="font-semibold">
              {item.tipo.replace(/_/g, " ")}
            </span>{" "}
            - {dataFormatada}
          </span>
          <MousePointerClick className="text-gray-600 text-sm" />
        </div>
      </div>
    );
  };

  const toggleTab = (
    tab: "meus" | "outros" | "sadt" | "receituarios" | "altas"
  ) => {
    setActiveTab((prev) => (prev === tab ? null : tab));
  };

  useEffect(() => {
    fetchReceituariosLaudos();
  }, [fetchReceituariosLaudos]);


  const salvarProntuario = () => {
    const textoLimpo = prontuarioAtual.replace(/[\s\u200B-\u200D\uFEFF]/g, "");
    if (!textoLimpo) {
      Swal.fire("Erro", "O campo de evoluÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o pode estar vazio.", "error");
      return;
    }

    Swal.fire({
      title: "VocÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª realmente deseja salvar as alteraÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âµes?",
      text: "As alteraÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âµes nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o poderÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o ser desfeitas.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, salvar!",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setSalvando(true);

        const token = sessionStorage.getItem("token");
        const cdPaciente = Number(Cookies.get("cdPaciente"));
        const nuCpf = Cookies.get("NuCPF") || "";
        const idEvent = Cookies.get("idEvent");
        const idProfissional = Number(Cookies.get("idProfissional"));

        try {
          const hoje = new Date().toISOString().split("T")[0];

          const response = await api.get(`/sisclinic/anamnese/cpf/${nuCpf}`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          const evolucoes = response.data;

          const evolucaoExistente = evolucoes.find((evo: any) => {
            const dataEvo = evo.dtHraEvolucao?.split("T")[0];
            return (
              dataEvo === hoje &&
              evo.idProfissional === idProfissional &&
              Number(evo.cdPaciente) === cdPaciente &&
              evo.nuCpf === nuCpf
            );
          });

          if (evolucaoExistente) {
            console.log("Atualizando evoluÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o existente:", {
              idEvolucao: evolucaoExistente.idEvolucao,
              dsEvolucao: prontuarioAtual,
            });

            await api.patch(
              `/sisclinic/prontuarios/${evolucaoExistente.idEvolucao}`,
              {
                dsEvolucao: prontuarioAtual,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            setProntuarioAtualId(evolucaoExistente.idEvolucao);
            setProntuarioAnexosId(evolucaoExistente.idEvolucao);
            setAnexosRefreshKey((prev) => prev + 1);
            Swal.fire("EvoluÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o atualizada com sucesso!", "", "success");
          } else {
            const novoProntuario = {
              cdPaciente,
              nuCpf,
              tipo: "EVOLUCAO",
              idProfissional,
              dsEvolucao: prontuarioAtual,
              localEvolucao: "SAD",
              maisSaude: 0,
            };

            console.log("Criando nova evoluÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o:", novoProntuario);

            const { data: prontuarioCriado } = await api.post(
              "/sisclinic/prontuarios",
              novoProntuario,
              {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
            const idCriado =
              Number(prontuarioCriado?.idEvolucao) ||
              Number(prontuarioCriado?.id) ||
              Number(prontuarioCriado?.idProntuario) ||
              null;
            if (idCriado) {
              setProntuarioAtualId(idCriado);
              setProntuarioAnexosId(idCriado);
              setAnexosRefreshKey((prev) => prev + 1);
            }
            Swal.fire("Prontuario salvo com sucesso!", "", "success");
          }

          console.log("Atualizando evento na agenda:", {
            idEvent,
            statusAgendamento: "ATENDIDO",
          });

          Cookies.set("atendimentoConcluido", "true");

          setEvolucaoEditando(null);
          setProntuarioAtual("");
          navigate("/RecordEdite");
        } catch (error) {
          console.error("Erro ao salvar prontuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rio:", error);
          Swal.fire(
            "Erro",
            "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o foi possÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­vel salvar os dados. Tente novamente.",
            "error"
          );
        } finally {
          setSalvando(false);
        }
      } else {
        Swal.fire("Atendimento encerrado.", "", "success");
      }
    });
  };

  const visualizarEvolucao = (evolucao: Evolucao) => {
    setProntuarioAtual(evolucao.dsEvolucao);
    setProntuarioAnexosId(evolucao.idEvolucao);
    setModoEdicao(false);
    setModalAberto(true);
  };

  let faEyeRenderizadoParaProfissional = false;

  const renderEvolucao = (evolucao: Evolucao) => {
    const isDoProfissional =
      evolucao.idProfissional === Number(Cookies.get("idProfissional"));

    const dataFormatada = new Date(evolucao.dtHraEvolucao).toLocaleDateString(
      "pt-BR",
      { day: "2-digit", month: "2-digit", year: "numeric" }
    );

    const handleVisualizar = () => {
      setShowButtons(false);
      visualizarEvolucao(evolucao);
    };

    // Se for do profissional, mostra apenas "Visualizar Prontuarios" uma vez
    if (isDoProfissional) {
      if (faEyeRenderizadoParaProfissional) {
        return null;
      }
      faEyeRenderizadoParaProfissional = true;

      return (
        <div
          key="meus-prontuarios"
          onClick={handleVisualizar}
          className="mb-2 p-2 border rounded-lg bg-gray-50 shadow-sm hover:shadow transition cursor-pointer text-xs"
        >
          <div className="flex items-center justify-between">
            <span className="text-gray-800">
              <span className="font-semibold">{"Visualizar Prontu\u00E1rios"}</span>
            </span>
            <MousePointerClick className="text-red-600 text-sm" />
          </div>
        </div>
      );
    }

    // Para outros profissionais
    return (
      <div
        key={evolucao.idEvolucao}
        onClick={handleVisualizar}
        className="mb-2 p-2 border rounded-lg bg-gray-50 shadow-sm hover:shadow transition cursor-pointer text-xs"
      >
        <div className="flex justify-between items-center">
          <p className="text-gray-700">
            <span className="font-bold">Data:</span> {dataFormatada} /{" "}
            <span className="font-bold">Prof:</span>{" "}
            {evolucao.profissional?.nmProfissional || "Vazio"}
          </p>
          <MousePointerClick className="text-blue-500 text-sm ml-1" />
        </div>
      </div>
    );
  };

  const getEspecialidadeDaEvolucao = (evolucao: Evolucao) =>
    evolucao.profissional?.especialidade?.dsEspecialidade?.trim() ||
    "Sem Especialidade";

  const groupByEspecialidade = (evolucoes: Evolucao[]) => {
    const agrupado = evolucoes.reduce((acc, evolucao) => {
      const especialidade = getEspecialidadeDaEvolucao(evolucao);
      if (!acc[especialidade]) {
        acc[especialidade] = [];
      }
      acc[especialidade].push(evolucao);
      return acc;
    }, {} as Record<string, Evolucao[]>);

    const ordenado: Record<string, Evolucao[]> = {};
    Object.keys(agrupado)
      .sort((a, b) => a.localeCompare(b))
      .forEach((especialidade) => {
        ordenado[especialidade] = agrupado[especialidade];
      });

    return ordenado;
  };

  const renderAtendimentos = () => {
    const groupedAtendimentos = groupByEspecialidade(outrosProfissionais);
    const groups = Object.entries(groupedAtendimentos).map(
      ([especialidade, items]) => {
        const profissionaisMap: Record<
          number,
          {
            idProfissional: number;
            nome: string;
            items: Evolucao[];
          }
        > = {};

        items.forEach((item) => {
          const idProfissional = Number(item.idProfissional);
          if (!profissionaisMap[idProfissional]) {
            profissionaisMap[idProfissional] = {
              idProfissional,
              nome: item.profissional?.nmProfissional || "Sem nome",
              items: [],
            };
          }
          profissionaisMap[idProfissional].items.push(item);
        });

        return {
          especialidade,
          profissionais: Object.values(profissionaisMap).sort((a, b) =>
            a.nome.localeCompare(b.nome, "pt-BR"),
          ),
        };
      },
    );

    return (
      <GroupedProfessionalsAccordion
        groups={groups}
        expandedEspecialidades={expandedEspecialidades}
        expandedProfissionais={expandedProfissionais}
        currentPages={outrosCurrentPages}
        itemsPerPage={outrosItensPorPagina}
        density="compact"
        onToggleEspecialidade={toggleEspecialidade}
        onToggleProfissional={toggleProfissional}
        onPageChange={handlePageChange2}
        renderItem={renderEvolucao}
      />
    );
  };


  const handlePageChange2 = (profissionalId: number, page: number) => {
    setCurrentPages((prev) => ({
      ...prev,
      [profissionalId]: page,
    }));
  };

  const LIMITE_CARACTERES = 4000000;

  const handleChange = (content: string) => {
    const trimmed = content.substring(0, LIMITE_CARACTERES);
    setProntuarioAtual(trimmed);
  };

  useEffect(() => {
    const atendimentoConcluido = Cookies.get("atendimentoConcluido");
    if (atendimentoConcluido === "true") {
      navigate("/Record", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      const cpf = Cookies.get("NuCPF");
      const token = sessionStorage.getItem("token");
      const meuIdProfissional = Number(Cookies.get("idProfissional"));

      try {
        const { data } = await api.get<Evolucao[]>(`/sisclinic/prontuarios/cpf/${cpf}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const meus = data
          .filter((e) => e.idProfissional === meuIdProfissional)
          .sort(
            (a, b) =>
              new Date(b.dtHraEvolucao).getTime() -
              new Date(a.dtHraEvolucao).getTime()
          );

        const outros = data
          .filter((e) => e.idProfissional !== meuIdProfissional)
          .sort(
            (a, b) =>
              new Date(b.dtHraEvolucao).getTime() -
              new Date(a.dtHraEvolucao).getTime()
          );

        const profissionaisIds = [
          ...new Set(
            outros
              .map((e) =>
                Number(e.idProfissional || e.profissional?.idProfissional),
              )
              .filter((id) => Number.isFinite(id) && id > 0),
          ),
        ];
        const especialidadesMap = await buscarEspecialidadesProfissionais(
          profissionaisIds,
          token,
        );

        const outrosComEspecialidade = outros.map((evolucao) => {
          const profissionalId = Number(
            evolucao.idProfissional || evolucao.profissional?.idProfissional,
          );

          return {
            ...evolucao,
            idProfissional:
              (Number.isFinite(profissionalId) && profissionalId > 0
                ? profissionalId
                : evolucao.idProfissional) || 0,
            profissional: {
              ...evolucao.profissional,
              especialidade: {
                ...evolucao.profissional?.especialidade,
                dsEspecialidade:
                  especialidadesMap[profissionalId] ||
                  evolucao.profissional?.especialidade?.dsEspecialidade ||
                  "Sem Especialidade",
              },
            },
          };
        });

        setMeusAtendimentos(meus);
        setOutrosProfissionais(outrosComEspecialidade);
        setOutrosCurrentPages({});

        const hoje = new Date().toISOString().split("T")[0];
        const cdPacienteAtual = Number(Cookies.get("cdPaciente"));
        const prontuarioAtualDoDia = meus.find((evolucao) => {
          const dataEvolucao = evolucao.dtHraEvolucao?.split("T")[0];
          return (
            dataEvolucao === hoje &&
            Number(evolucao.cdPaciente) === cdPacienteAtual
          );
        });

        setProntuarioAtualId(prontuarioAtualDoDia?.idEvolucao || null);
        setProntuarioAnexosId(prontuarioAtualDoDia?.idEvolucao || null);
      } catch (error) {
        console.error("Erro ao buscar os prontuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rios:", error);
      }
    };

    fetchData();
  }, []);

useEffect(() => {
  const hoje = new Date();
  const dataEvolucao = hoje.toISOString().split("T")[0];
  const token = sessionStorage.getItem("token");

  const fetchProntuario = async () => {
    try {
      const response = await api.get("/sisclinic/prontuarios/visualizar", {
        params: {
          idEvent,
          nome,
          cdPaciente,
          idProfissional,
          dataEvolucao,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // Usar a variÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡vel response
      const idProntuarioVisualizado = Number(
        response.data?.idEvolucao ??
          response.data?.prontuario?.idEvolucao ??
          response.data?.id ??
          0,
      );

      if (idProntuarioVisualizado > 0) {
        setProntuarioAtualId(idProntuarioVisualizado);
        setProntuarioAnexosId(idProntuarioVisualizado);
      }
      console.log("Prontuario carregado:", response.data);
    } catch (error) {
      console.error("Erro ao buscar prontuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rio:", error);
    }
  };

  if (idEvent && nome && cdPaciente && idProfissional) {
    fetchProntuario();
  }
}, [idEvent, nome, cdPaciente, idProfissional]);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (token) {
      api
        .get("/sisclinic/profissionais", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => setProfissionais(res.data))
        .catch((err) => console.error("Erro ao buscar profissionais:", err));
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLoadingMeus(false);
      setLoadingOutros(false);
    }, 1500);
  }, []);

  useEffect(() => {
    const fetchEspecialidades = async () => {
      try {
        const response = await api.get("/sisclinic/especialidades");
        setEspecialidades(response.data);
      } catch (error) {
        console.error("Erro ao buscar especialidades:", error);
      }
    };

    fetchEspecialidades();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!isOpen) return;

      const cdPaciente = Cookies.get("cdPaciente");
      const token = sessionStorage.getItem("token");

      if (cdPaciente && token) {
        try {
          const response = await api.get(`/mais-saude/paciente/${cdPaciente}`, {
            headers: {
              "Cache-Control": "no-cache",
              Authorization: `Bearer ${token}`,
            },
          });

          const data = response.data;

          if (Array.isArray(data)) {
            setCiclos(data);
          } else if (data && Array.isArray(data.ciclos)) {
            setCiclos(data.ciclos);
          } else {
            console.warn("Formato inesperado de resposta da API:", data);
          }
        } catch (err) {
          console.error("Erro ao buscar ciclos:", err);
        }
      } else {
        console.error("cdPaciente ou token nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o encontrado");
      }
    };

    fetchData();
  }, [isOpen]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setModalAberto(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const atendimentoConcluido = Cookies.get("atendimentoConcluido");
    if (atendimentoConcluido === "true") {
      navigate("/Record", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const atendimentoNutricionistaConcluido = Cookies.get(
      "atendimentoNutricionistaConcluido"
    );
    if (atendimentoNutricionistaConcluido === "true") {
      navigate("/medico/atendimentonutricionista", { replace: true });
    }
  }, [navigate]);

  const atualizarAgenda = () => {
    window.location.reload();
  };

  // 1. Atestado MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©dico
  const handleGenerateAtestadoPDF = async (item: ReceituarioLaudo) => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });

    // ConfiguraÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âµes de layout
    const marginLeft = 40;
    const marginRight = 40;
    const marginTop = 0;
    const pageWidth =
      doc.internal.pageSize.getWidth() - marginLeft - marginRight;
    const centerX = doc.internal.pageSize.getWidth() / 2;

    // 1. Logo no topo (centralizada)
    const logoImg = new Image();
    logoImg.src = Logo;

    await new Promise((resolve) => {
      logoImg.onload = () => {
        const logoWidth = 600;
        const logoHeight = (logoImg.height * logoWidth) / logoImg.width;
        doc.addImage(
          logoImg,
          "PNG",
          centerX - logoWidth / 2,
          marginTop,
          logoWidth,
          logoHeight
        );
        resolve(null);
      };
    });

    // 2. CabeÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§alho textual
    const headerY = marginTop + 150;
    doc.setFontSize(12);
    doc.setTextColor(36, 99, 235); // Azul #2463EB
    doc.text(
      "AssociaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o dos Auditores Fiscais do Estado da ParaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­ba",
      centerX,
      headerY,
      { align: "center" }
    );

    // 3. TÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­tulo principal
    doc.setFontSize(18);
    doc.setTextColor(36, 99, 235);
    doc.setFont("helvetica", "bold");
    doc.text("ATESTADO MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?DICO", centerX, headerY + 30, { align: "center" });

    // 4. Conteudo do atestado
    const contentY = headerY + 80;
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");

    // Primeiro parÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡grafo
    let yPosition = contentY;
    const firstParagraph = `Atesto, para os devidos fins, a pedido do interessado, que o Sr.(a) ${
      item.paciente.nmPaciente
    }, portador do CPF: ${
      item.paciente.nuCpf
    } foi submetido ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â  consulta nesta data, no horÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rio das ${
      item.hrConsulta || "nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"
    }, sendo portador de afecÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o CID-${item.cid || "nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"}.`;
    const splitFirstParagraph = doc.splitTextToSize(firstParagraph, pageWidth);
    doc.text(splitFirstParagraph, marginLeft, yPosition);
    yPosition += splitFirstParagraph.length * 20;

    // Segundo parÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡grafo
    const diasAfastamento = item.atestadoQtdDias || 0;
    const diasEscritoAfastamento = diasPorExtenso(diasAfastamento);
    const dataAtestado =
      formatDate(item.dtConsulta) || new Date().toLocaleDateString("pt-BR");

    const secondParagraph = `Em decorrÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia deverÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ permanecer afastado de suas atividades laborativas por um perÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­odo de ${diasAfastamento} (${diasEscritoAfastamento}) dia(s) a partir desta data. JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa, ${dataAtestado}.`;
    const splitSecondParagraph = doc.splitTextToSize(
      secondParagraph,
      pageWidth
    );
    doc.text(splitSecondParagraph, marginLeft, yPosition + 20);
    yPosition += splitSecondParagraph.length * 20 + 40;

    // 5. Assinatura
    doc.text("_________________________________________", centerX, yPosition, {
      align: "center",
    });
    doc.setFont("helvetica", "bold");
    doc.text(
      `Dr. ${item.profissional.nmProfissional}`,
      centerX,
      yPosition + 20,
      {
        align: "center",
      }
    );
    // 6. SeÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o de AutorizaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o
    yPosition += 140;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("AutorizaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o", centerX, yPosition, { align: "center" });
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    const authorizationText = `Eu, ${
      item.paciente.nmPaciente
    }, autorizo o Dr. ${
      item.profissional.nmProfissional
    } a registrar o diagnÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³stico (codificado - CID: ${
      item.cid || "nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"
    } ou por extenso) neste atestado.`;
    const splitAuthorization = doc.splitTextToSize(
      authorizationText,
      pageWidth
    );
    doc.text(splitAuthorization, marginLeft, yPosition + 30);

    yPosition += splitAuthorization.length * 20 + 60;
    doc.text("_________________________________________", centerX, yPosition, {
      align: "center",
    });
    doc.text("Assinatura do UsuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rio - RG", centerX, yPosition + 20, {
      align: "center",
    });

    // 7. Marca d'ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡gua
    const watermarkImg = new Image();
    watermarkImg.src = WatermarkLogo;

    await new Promise((resolve) => {
      watermarkImg.onload = () => {
        const watermarkWidth = 300;
        const watermarkHeight =
          (watermarkImg.height * watermarkWidth) / watermarkImg.width;
        const centerX = doc.internal.pageSize.getWidth() / 2;
        const centerY = doc.internal.pageSize.getHeight() / 2;

        const canvas = document.createElement("canvas");
        canvas.width = watermarkImg.width;
        canvas.height = watermarkImg.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        ctx.drawImage(watermarkImg, 0, 0, canvas.width, canvas.height);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
          if (data[i] > 150 && data[i + 1] < 80 && data[i + 2] < 80) {
            data[i] = 36; // R
            data[i + 1] = 99; // G
            data[i + 2] = 235; // B
            data[i + 3] = 51; // Opacidade (~20%)
          }
        }

        ctx.putImageData(imageData, 0, 0);
        doc.addImage(
          canvas,
          "PNG",
          centerX - watermarkWidth / 2,
          centerY - watermarkHeight / 2,
          watermarkWidth,
          watermarkHeight
        );
        resolve(null);
      };
    });

    // 8. RodapÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©
    const footerY = doc.internal.pageSize.getHeight() - 80;
    doc.setFontSize(8);
    doc.setTextColor(36, 99, 235);

    // Coluna da esquerda
    const leftColX = marginLeft;
    doc.text(
      "Rua CorÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡lio Soares de Oliveira, 497 ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ Centro, JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ PB",
      leftColX,
      footerY
    );
    doc.text("Fone: (83) 3533.5310 | 3533.5311", leftColX, footerY + 15);
    doc.text("www.afrafep.org.br", leftColX, footerY + 30);
    doc.text("INSC. ANS NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â° 330281", leftColX, footerY + 45);

    // Coluna da direita
    const rightColX = doc.internal.pageSize.getWidth() - marginRight - 200;
    doc.text("ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?tica e TransparÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia", rightColX, footerY);
    doc.text(
      "Solidariedade e Responsabilidade Social",
      rightColX,
      footerY + 15
    );
    doc.text("Comprometimento e Profissionalismo", rightColX, footerY + 30);
    doc.text("Legalidade e Respeito", rightColX, footerY + 45);

    // Gerar PDF e abrir diÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡logo de impressÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o diretamente
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Criar iframe para impressÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o automÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡tica
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    iframe.onload = function () {
      setTimeout(function () {
        iframe.contentWindow?.print();
      }, 500);
    };

    return pdfBlob;
  };

  const handleGenerateAltaFisioPDF = async (item: ReceituarioLaudo) => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });

    // ConfiguraÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âµes de layout
    const marginLeft = 40;
    const marginRight = 40;
    const marginTop = 0;
    const pageWidth =
      doc.internal.pageSize.getWidth() - marginLeft - marginRight;
    const centerX = doc.internal.pageSize.getWidth() / 2;

    // Capturar CRM do cookie
    const CRM = Cookies.get("CRM");

    // 1. Logo no topo
    const logoImg = new Image();
    logoImg.src = Logo;

    await new Promise((resolve) => {
      logoImg.onload = () => {
        const logoWidth = 600;
        const logoHeight = (logoImg.height * logoWidth) / logoImg.width;
        doc.addImage(
          logoImg,
          "PNG",
          centerX - logoWidth / 2,
          marginTop,
          logoWidth,
          logoHeight
        );
        resolve(null);
      };
    });

    // 2. CabeÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§alho textual
    const headerY = marginTop + 150;
    doc.setFontSize(15);
    doc.setTextColor(36, 99, 235);
    doc.text(
      "AssociaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o dos Auditores Fiscais do Estado da ParaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­ba",
      centerX,
      headerY,
      { align: "center" }
    );

    // 3. TÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­tulo principal
    doc.setFontSize(18);
    doc.setTextColor(36, 99, 235);
    doc.setFont("helvetica", "bold");
    doc.text("ALTA FISIOTERAPIA", centerX, headerY + 30, { align: "center" });

    // 4. Nome do paciente
    const pacienteY = headerY + 60;
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    doc.text(
      `Paciente: ${item.paciente?.nmPaciente || "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"}`,
      marginLeft,
      pacienteY
    );

    // 5. Conteudo da prescriÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o
    const contentY = pacienteY + 30;
    doc.setFont("helvetica", "bold");
    doc.text("PrescriÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o:", marginLeft, contentY);

    doc.setFont("helvetica", "normal");
    const contentText = htmlToFormattedText(item.prescricao);
    const splitText = doc.splitTextToSize(contentText, pageWidth);

    const lineHeight = 14;
    let currentY = contentY + 20;

    for (let i = 0; i < splitText.length; i++) {
      doc.text(splitText[i], marginLeft, currentY);
      currentY += lineHeight;
    }

    // 6. Marca d'ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡gua
    const watermarkImg = new Image();
    watermarkImg.src = WatermarkLogo;

    await new Promise((resolve) => {
      watermarkImg.onload = () => {
        const watermarkWidth = 300;
        const watermarkHeight =
          (watermarkImg.height * watermarkWidth) / watermarkImg.width;
        const centerX = doc.internal.pageSize.getWidth() / 2;
        const centerY = doc.internal.pageSize.getHeight() / 2;

        const canvas = document.createElement("canvas");
        canvas.width = watermarkImg.width;
        canvas.height = watermarkImg.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        ctx.drawImage(watermarkImg, 0, 0, canvas.width, canvas.height);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
          if (data[i] > 150 && data[i + 1] < 80 && data[i + 2] < 80) {
            data[i] = 36;
            data[i + 1] = 99;
            data[i + 2] = 235;
            data[i + 3] = 51;
          }
        }

        ctx.putImageData(imageData, 0, 0);
        doc.addImage(
          canvas,
          "PNG",
          centerX - watermarkWidth / 2,
          centerY - watermarkHeight / 2,
          watermarkWidth,
          watermarkHeight
        );
        resolve(null);
      };
    });

    // 7. Assinatura
    const signatureY = doc.internal.pageSize.getHeight() - 180;

    // Linha de assinatura
    doc.text("_________________________________________", centerX, signatureY, {
      align: "center",
    });

    // Nome do profissional
    doc.setFont("helvetica", "bold");
    doc.text(
      `Dr. ${item.profissional.nmProfissional}`,
      centerX,
      signatureY + 20,
      { align: "center" }
    );

    // CRM do profissional
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    doc.text(`CRM: ${CRM ? CRM : "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"}`, centerX, signatureY + 40, {
      align: "center",
    });

    // Data alinhada ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â  direita abaixo do CRM
    const dataAtual = new Date().toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const pageTotalWidth = doc.internal.pageSize.getWidth();

    doc.text(
      `Data: ${dataAtual}`,
      pageTotalWidth - marginRight,
      signatureY + 60,
      {
        align: "right",
      }
    );

    // 8. RodapÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©
    const footerY = doc.internal.pageSize.getHeight() - 80;
    doc.setFontSize(9);

    // Coluna da esquerda
    doc.setTextColor(0, 0, 0);
    const leftColX = marginLeft;
    doc.text(
      "Rua CorÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡lio Soares de Oliveira, 497 ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ Centro, JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ PB",
      leftColX,
      footerY
    );
    doc.text("Fone: (83) 3533.5310 | 3533.5311", leftColX, footerY + 15);
    doc.text("www.afrafep.org.br", leftColX, footerY + 30);
    doc.text("INSC. ANS NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â° 330281", leftColX, footerY + 45);

    // Coluna da direita
    doc.setTextColor(0, 0, 255);
    const rightColX = marginLeft + pageWidth / 2 + 80;
    doc.text("ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?tica e TransparÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia", rightColX, footerY);
    doc.text(
      "Solidariedade e Responsabilidade Social",
      rightColX,
      footerY + 15
    );
    doc.text("Comprometimento e Profissionalismo", rightColX, footerY + 30);
    doc.text("Legalidade e Respeito", rightColX, footerY + 45);

    // 9. Gerar PDF e abrir diÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡logo de impressÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    iframe.onload = function () {
      setTimeout(function () {
        iframe.contentWindow?.print();
      }, 500);
    };

    return pdfBlob;
  };

  // ADICIONAR ESTA FUNÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO NO SEU COMPONENTE (se ainda nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o tiver)
  const htmlToFormattedText = (html: string): string => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const processNode = (node: Node): string => {
      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent?.replace(/\s+/g, " ") || "";
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node as HTMLElement;

        switch (element.tagName.toLowerCase()) {
          case "p":
            return (
              Array.from(element.childNodes).map(processNode).join("") + "\n"
            );
          case "br":
            return "\n";
          case "div":
            return (
              Array.from(element.childNodes).map(processNode).join("") + "\n"
            );
          case "strong":
          case "b":
            return Array.from(element.childNodes).map(processNode).join("");
          case "em":
          case "i":
            return Array.from(element.childNodes).map(processNode).join("");
          case "ul":
            return Array.from(element.children)
              .map((li) => "ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ " + processNode(li) + "\n")
              .join("");
          case "ol":
            return Array.from(element.children)
              .map((li, index) => index + 1 + ". " + processNode(li) + "\n")
              .join("");
          case "li":
            return Array.from(element.childNodes)
              .map(processNode)
              .join("")
              .trim();
          default:
            return Array.from(element.childNodes).map(processNode).join("");
        }
      }
      return "";
    };

    let result = Array.from(tempDiv.childNodes).map(processNode).join("");

    // Reduz mÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºltiplas quebras de linha consecutivas
    result = result
      .replace(/\n\s*\n/g, "\n")
      .replace(/\n{3,}/g, "\n\n")
      .replace(/[ \t]+/g, " ")
      .trim();

    return result;
  };

  const handleGenerateLaudoPDF = async (item: ReceituarioLaudo) => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });

    const marginLeft = 40;
    const marginRight = 40;
    const marginTop = 0;
    const pageWidth =
      doc.internal.pageSize.getWidth() - marginLeft - marginRight;
    const pageHeight = doc.internal.pageSize.getHeight();
    const centerX = doc.internal.pageSize.getWidth() / 2;
    const lineHeight = 14;
    const bottomMargin = 180;

    // Carregar imagens
    const logoImg = new Image();
    logoImg.src = Logo;
    const watermarkImg = new Image();
    watermarkImg.src = WatermarkLogo;
    await Promise.all([
      new Promise((resolve) => (logoImg.onload = resolve)),
      new Promise((resolve) => (watermarkImg.onload = resolve)),
    ]);

    const drawHeader = () => {
      const logoWidth = 600;
      const logoHeight = (logoImg.height * logoWidth) / logoImg.width;
      doc.addImage(
        logoImg,
        "PNG",
        centerX - logoWidth / 2,
        marginTop,
        logoWidth,
        logoHeight
      );

      const headerY = marginTop + 150;
      doc.setFontSize(15);
      doc.setTextColor(36, 99, 235);
      doc.text(
        "AssociaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o dos Auditores Fiscais do Estado da ParaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­ba",
        centerX,
        headerY,
        { align: "center" }
      );

      doc.setFontSize(18);
      doc.setFont("helvetica", "bold");
      doc.text("LAUDO", centerX, headerY + 30, { align: "center" });

      const watermarkWidth = 300;
      const watermarkHeight =
        (watermarkImg.height * watermarkWidth) / watermarkImg.width;
      const canvas = document.createElement("canvas");
      canvas.width = watermarkImg.width;
      canvas.height = watermarkImg.height;
      const ctx = canvas.getContext("2d");
      if (!ctx) throw new Error("NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o foi possÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­vel obter o contexto 2D");
      ctx.drawImage(watermarkImg, 0, 0, canvas.width, canvas.height);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      for (let i = 0; i < data.length; i += 4) {
        if (data[i] > 150 && data[i + 1] < 80 && data[i + 2] < 80) {
          data[i] = 36;
          data[i + 1] = 99;
          data[i + 2] = 235;
          data[i + 3] = 51;
        }
      }
      ctx.putImageData(imageData, 0, 0);
      doc.addImage(
        canvas,
        "PNG",
        centerX - watermarkWidth / 2,
        pageHeight / 2 - watermarkHeight / 2,
        watermarkWidth,
        watermarkHeight
      );

      return headerY + 80;
    };

    let y = drawHeader();

    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0);

    doc.setFont("helvetica", "bold");
    doc.text("Nome: ", marginLeft, y);
    const nomeWidth = doc.getTextWidth("Nome: ");
    doc.setFont("helvetica", "normal");
    doc.text(item.paciente.nmPaciente, marginLeft + nomeWidth, y);
    y += 30;

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("Laudo:", marginLeft, y);
    y += 20;
    doc.setFont("helvetica", "normal");

    const contentText = item.prescricao.replace(/<[^>]*>/g, "");
    const splitText = doc.splitTextToSize(contentText, pageWidth);

    splitText.forEach((line: string) => {
      if (y + lineHeight > pageHeight - bottomMargin) {
        doc.addPage();
        y = drawHeader();
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "bold");
        doc.text("Laudo (continuaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o):", marginLeft, y);
        y += 20;
        doc.setFont("helvetica", "normal");
      }
      doc.text(line, marginLeft, y);
      y += lineHeight;
    });

    const signatureY = pageHeight - 180;
    doc.text("_________________________________________", centerX, signatureY, {
      align: "center",
    });

    // === CRM abaixo do nome ===
    let CRM: string | undefined =
      (item as any)?.profissional?.CRM ||
      (typeof Cookies !== "undefined" && Cookies?.get
        ? Cookies.get("CRM")
        : "");

    doc.setFont("helvetica", "bold");
    doc.text(
      `Dr. ${item.profissional.nmProfissional}`,
      centerX,
      signatureY + 20,
      {
        align: "center",
      }
    );

    if (CRM) {
      doc.setFont("helvetica", "normal");
      doc.text(`CRM: ${CRM}`, centerX, signatureY + 38, { align: "center" });
    }

    // Data
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    const dataGeracao = new Date().toLocaleDateString("pt-BR");
    doc.text(`Data: ${dataGeracao}`, centerX, signatureY + 60, {
      align: "center",
    });

    // RodapÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©
    const footerY = pageHeight - 80;
    doc.setFontSize(9);
    doc.setTextColor(0, 0, 0);
    doc.text(
      "Rua CorÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡lio Soares de Oliveira, 497 ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ Centro, JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ PB",
      marginLeft,
      footerY
    );
    doc.text("Fone: (83) 3533.5310 | 3533.5311", marginLeft, footerY + 15);
    doc.text("www.afrafep.org.br", marginLeft, footerY + 30);
    doc.text("INSC. ANS NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â° 330281", marginLeft, footerY + 45);

    doc.setTextColor(0, 0, 255);
    const rightColX = marginLeft + pageWidth / 2 + 80;
    doc.text("ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?tica e TransparÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia", rightColX, footerY);
    doc.text(
      "Solidariedade e Responsabilidade Social",
      rightColX,
      footerY + 15
    );
    doc.text("Comprometimento e Profissionalismo", rightColX, footerY + 30);
    doc.text("Legalidade e Respeito", rightColX, footerY + 45);

    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    iframe.onload = function () {
      setTimeout(function () {
        iframe.contentWindow?.print();
      }, 500);
    };

    return pdfBlob;
  };

  const handleGenerateReceituarioPDF = async (item: ReceituarioLaudo) => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });

    // === Pega CRM do cookie ===
    const cookies = document.cookie
      .split(";")
      .map((cookie) => cookie.trim())
      .reduce((acc: Record<string, string>, cookie) => {
        const [name, value] = cookie.split("=");
        acc[name] = decodeURIComponent(value);
        return acc;
      }, {});
    const CRM = cookies["CRM"];

    // === ConfiguraÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âµes de layout ===
    const marginLeft = 40;
    const marginRight = 40;
    const marginTop = 0;
    const pageWidth =
      doc.internal.pageSize.getWidth() - marginLeft - marginRight;
    const centerX = doc.internal.pageSize.getWidth() / 2;
    const maxHeight = doc.internal.pageSize.getHeight();
    const bottomMargin = 180;

    // === Logo no topo ===
    const logoImg = new Image();
    logoImg.src = Logo;

    await new Promise((resolve) => {
      logoImg.onload = () => {
        const logoWidth = 600;
        const logoHeight = (logoImg.height * logoWidth) / logoImg.width;
        doc.addImage(
          logoImg,
          "PNG",
          centerX - logoWidth / 2,
          marginTop,
          logoWidth,
          logoHeight
        );
        resolve(null);
      };
    });

    // === CabeÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§alho ===
    const headerY = marginTop + 150;
    doc.setFontSize(15);
    doc.setTextColor(36, 99, 235);
    doc.text(
      "AssociaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o dos Auditores Fiscais do Estado da ParaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­ba",
      centerX,
      headerY,
      { align: "center" }
    );

    doc.setFontSize(18);
    doc.setTextColor(36, 99, 235);
    doc.setFont("helvetica", "bold");
    doc.text("RECEITUÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚ÂRIO COMUM", centerX, headerY + 30, { align: "center" });

    // === Dados do paciente ===
    const patientY = headerY + 70;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(
      `Paciente: ${item.paciente?.nmPaciente || "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"}`,
      marginLeft,
      patientY
    );

    // === Conteudo da prescriÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o ===
    const contentY = patientY + 30;
    doc.setFont("helvetica", "bold");
    doc.text("PrescriÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o:", marginLeft, contentY);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);

    const contentText = item.prescricao
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p><p>/gi, "\n")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();

    const splitText = doc.splitTextToSize(contentText, pageWidth - 20);
    const lineHeight = 14;
    let currentY = contentY + 20;

    for (let i = 0; i < splitText.length; i++) {
      if (currentY + lineHeight > maxHeight - bottomMargin) {
        doc.addPage();
        currentY = marginTop + 40;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(11);
        doc.text("PrescriÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o (continuaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o):", marginLeft, currentY);
        currentY += 20;
        doc.setFont("helvetica", "normal");
      }

      doc.text(splitText[i], marginLeft + 10, currentY);
      currentY += lineHeight;
    }

    // === Marca d'ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡gua (somente na primeira pÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡gina) ===
    const watermarkImg = new Image();
    watermarkImg.src = WatermarkLogo;

    await new Promise((resolve) => {
      watermarkImg.onload = () => {
        const watermarkWidth = 300;
        const watermarkHeight =
          (watermarkImg.height * watermarkWidth) / watermarkImg.width;
        const centerY = doc.internal.pageSize.getHeight() / 2;

        const canvas = document.createElement("canvas");
        canvas.width = watermarkImg.width;
        canvas.height = watermarkImg.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        ctx.drawImage(watermarkImg, 0, 0, canvas.width, canvas.height);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
          if (data[i] > 150 && data[i + 1] < 80 && data[i + 2] < 80) {
            data[i] = 36;
            data[i + 1] = 99;
            data[i + 2] = 235;
            data[i + 3] = 51;
          }
        }

        ctx.putImageData(imageData, 0, 0);

        const currentPage = doc.getCurrentPageInfo().pageNumber;
        doc.setPage(1);
        doc.addImage(
          canvas,
          "PNG",
          centerX - watermarkWidth / 2,
          centerY - watermarkHeight / 2,
          watermarkWidth,
          watermarkHeight,
          undefined,
          "FAST"
        );
        doc.setPage(currentPage);
        resolve(null);
      };
    });

    // === Assinatura na ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºltima pÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡gina ===
    const signatureY = maxHeight - 210;
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text("_________________________________________", centerX, signatureY, {
      align: "center",
    });

    doc.setFont("helvetica", "bold");
    doc.text(
      `Dr. ${item.profissional.nmProfissional}`,
      centerX,
      signatureY + 20,
      { align: "center" }
    );

    // CRM abaixo do nome
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    doc.text(`CRM: ${CRM ? CRM : "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"}`, centerX, signatureY + 40, {
      align: "center",
    });

    // === Data abaixo do CRM ===
    const dataGeracao = new Date().toLocaleDateString("pt-BR");
    doc.setFontSize(11);
    doc.text(`Data: ${dataGeracao}`, centerX, signatureY + 60, {
      align: "center",
    });

    // === RodapÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â© em todas as pÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ginas ===
    const totalPages = doc.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      const footerY = maxHeight - 80;
      doc.setFontSize(9);

      doc.setTextColor(0, 0, 0);
      const leftColX = marginLeft;
      doc.text(
        "Rua CorÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡lio Soares de Oliveira, 497 ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ Centro, JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ PB",
        leftColX,
        footerY
      );
      doc.text("Fone: (83) 3533.5310 | 3533.5311", leftColX, footerY + 15);
      doc.text("www.afrafep.org.br", leftColX, footerY + 30);
      doc.text("INSC. ANS NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â° 330281", leftColX, footerY + 45);

      doc.setTextColor(0, 0, 255);
      const rightColX = marginLeft + pageWidth / 2 + 80;
      doc.text("ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?tica e TransparÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia", rightColX, footerY);
      doc.text(
        "Solidariedade e Responsabilidade Social",
        rightColX,
        footerY + 15
      );
      doc.text("Comprometimento e Profissionalismo", rightColX, footerY + 30);
      doc.text("Legalidade e Respeito", rightColX, footerY + 45);
    }

    // === Gerar e imprimir ===
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    iframe.onload = function () {
      setTimeout(function () {
        iframe.contentWindow?.print();
      }, 500);
    };

    return pdfBlob;
  };

  const handleGenerateReceituarioEspecialPDF = async (
    item: ReceituarioLaudo
  ) => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "pt",
      format: "a4",
    });

    // Pega o CRM do cookie
    const CRM = Cookies.get("CRM") || "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado";

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const halfWidth = pageWidth / 2;
    const margin = 40;
    const footerHeight = 120;

    // FunÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o para adicionar marca d'ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡gua
    const addWatermark = async (x: number, y: number, width: number) => {
      const watermarkImg = new Image();
      watermarkImg.src = WatermarkLogo;

      return new Promise((resolve) => {
        watermarkImg.onload = () => {
          const watermarkHeight =
            (watermarkImg.height * width) / watermarkImg.width;

          const canvas = document.createElement("canvas");
          canvas.width = watermarkImg.width;
          canvas.height = watermarkImg.height;
          const ctx = canvas.getContext("2d");
          if (!ctx) return;

          ctx.drawImage(watermarkImg, 0, 0, canvas.width, canvas.height);
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const data = imageData.data;

          // Ajustar cores conforme layout desejado
          for (let i = 0; i < data.length; i += 4) {
            if (data[i] > 150 && data[i + 1] < 80 && data[i + 2] < 80) {
              data[i] = 36;
              data[i + 1] = 99;
              data[i + 2] = 235;
              data[i + 3] = 30;
            }
          }

          ctx.putImageData(imageData, 0, 0);

          doc.addImage(
            canvas,
            "PNG",
            x + (halfWidth - width) / 2,
            y + (pageHeight - watermarkHeight) / 2,
            width,
            watermarkHeight,
            undefined,
            "FAST"
          );
          resolve(null);
        };
      });
    };

    // CabeÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§alho
    const addHeader = async (x: number, y: number): Promise<number> => {
      const logoImg = new Image();
      logoImg.src = Logo;

      return new Promise((resolve) => {
        logoImg.onload = () => {
          const logoWidth = halfWidth - margin * 2;
          const logoHeight = (logoImg.height * logoWidth) / logoImg.width;

          doc.addImage(logoImg, "PNG", x + margin, y, logoWidth, logoHeight);

          // Texto com ambas as vias
          doc.setFontSize(9);
          doc.setTextColor(0, 0, 0);
          doc.text(
            "1ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª Via - RetenÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o da FarmÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡cia ou Drogaria",
            x + halfWidth - margin,
            y + logoHeight + 12,
            { align: "right" }
          );
          doc.text(
            "2ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª Via - OrientaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o ao Paciente",
            x + halfWidth - margin,
            y + logoHeight + 24,
            { align: "right" }
          );

          resolve(logoHeight);
        };
      });
    };

    // RodapÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©
    const addFooter = (x: number, y: number) => {
      doc.setFontSize(6);
      doc.setTextColor(100, 100, 100);

      const leftColX = x + margin;
      const startY = y + 20;

      doc.text(
        "Rua CorÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡lio Soares de Oliveira, 497 ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ Centro, JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ PB",
        leftColX,
        startY
      );
      doc.text("Fone: (83) 3533.5310 | 3533.5311", leftColX, startY + 10);
      doc.text("www.afrafep.org.br", leftColX, startY + 20);
      doc.text("INSC. ANS NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â° 330281", leftColX, startY + 30);

      doc.setTextColor(0, 0, 200);
      const rightColX = x + halfWidth - margin - 120;
      doc.setFontSize(6);
      doc.text("ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?tica e TransparÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia", rightColX, startY);
      doc.text(
        "Solidariedade e Responsabilidade Social",
        rightColX,
        startY + 10
      );
      doc.text("Comprometimento e Profissionalismo", rightColX, startY + 20);
      doc.text("Legalidade e Respeito", rightColX, startY + 30);
    };

    // Conteudo principal
    const drawContent = async (x: number, y: number) => {
      let currentY = y;

      // Marca d'ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡gua
      await addWatermark(x, currentY, 180);

      // CabeÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§alho
      const logoHeight = await addHeader(x, currentY);
      currentY += logoHeight + 40;

      // TÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­tulo RECEITUÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚ÂRIO ESPECIAL
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text("RECEITUÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚ÂRIO CONTROLE ESPECIAL", x + halfWidth / 2, currentY, {
        align: "center",
      });
      currentY += 25;

      // IdentificaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o do Emitente
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("IDENTIFICAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO DO EMITENTE", x + margin, currentY);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.text(
        `Nome completo: Dr. ${item.profissional.nmProfissional}`,
        x + margin,
        currentY + 18
      );

      doc.text(`CRM: ${CRM}`, x + margin, currentY + 32);

      doc.text("CNPJ: 09.306.242/0001-82", x + margin, currentY + 46);

      const enderecoEmitenteText = doc.splitTextToSize(
        "Endereco completo e Telefone: Rua Coralio Soares de Oliveira - 497, Centro (83) 3533.5310",
        halfWidth - margin * 2 - 15
      );
      doc.text(enderecoEmitenteText, x + margin, currentY + 60);

      const enderecoEmitenteHeight = enderecoEmitenteText.length * 9;
      doc.text(
        "Cidade: JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa",
        x + margin,
        currentY + 60 + enderecoEmitenteHeight + 8
      );
      doc.text(
        "UF: ParaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­ba",
        x + margin,
        currentY + 60 + enderecoEmitenteHeight + 20
      );

      currentY += 60 + enderecoEmitenteHeight + 35;

      // Linha divisÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³ria
      doc.setDrawColor(200, 200, 200);
      doc.line(x + margin, currentY, x + halfWidth - margin, currentY);
      currentY += 12;

      // InformaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âµes do Paciente
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("INFORMAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½.ES DO PACIENTE", x + margin, currentY);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      const pacienteText = doc.splitTextToSize(
        `Paciente: ${item.paciente.nmPaciente || "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"}`,
        halfWidth - margin * 2
      );
      doc.text(pacienteText, x + margin, currentY + 18);

      const enderecoPacienteText = doc.splitTextToSize(
        `EndereÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§o: ${item.paciente.nmEndereco || "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"}`,
        halfWidth - margin * 2
      );
      doc.text(enderecoPacienteText, x + margin, currentY + 32);

      const enderecoPacienteHeight = enderecoPacienteText.length * 9;
      currentY += 32 + enderecoPacienteHeight + 8;

      doc.line(x + margin, currentY, x + halfWidth - margin, currentY);
      currentY += 12;

      // PrescriÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©dica
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("PRESCRIÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?DICA", x + margin, currentY);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = item.prescricao;
      const prescricaoText = tempDiv.textContent || tempDiv.innerText || "";
      const splitPrescricao = doc.splitTextToSize(
        prescricaoText,
        halfWidth - margin * 2
      );

      currentY += 18;
      for (let i = 0; i < splitPrescricao.length; i++) {
        if (currentY > pageHeight - footerHeight - 20) {
          addFooter(x, pageHeight - footerHeight);
          doc.addPage();
          currentY = margin;
          await addWatermark(x, currentY, 180);
          const newLogoHeight = await addHeader(x, currentY);
          currentY += newLogoHeight + 35;
        }
        doc.text(splitPrescricao[i], x + margin, currentY);
        currentY += 11;
      }

      currentY += 18;

      // Assinatura do MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©dico
      const signatureLineLength = (halfWidth - margin * 2) * 0.6;
      const signatureLineX = x + (halfWidth - signatureLineLength) / 2;
      doc.setDrawColor(0, 0, 0);
      doc.line(
        signatureLineX,
        currentY,
        signatureLineX + signatureLineLength,
        currentY
      );

      doc.setFontSize(8);
      doc.setFont("helvetica", "bold");
      doc.text(
        "CARIMBO E ASSINATURA DO MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?DICO",
        x + halfWidth / 2,
        currentY + 12,
        { align: "center" }
      );

      // ADICIONANDO O CRM APÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½"S O CARIMBO
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.text(`CRM: ${CRM}`, x + halfWidth / 2, currentY + 24, {
        align: "center",
      });

      // Data
      doc.setFont("helvetica", "normal");
      const dataAtual = new Date().toLocaleDateString("pt-BR");
      doc.text(`Data: ${dataAtual}`, x + margin, currentY + 27);
      currentY += 45;

      // IdentificaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o do Comprador e Fornecedor
      const colWidth = (halfWidth - margin * 2 - 20) / 2;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text(
        "IDENTIFICAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO DO COMPRADOR",
        x + margin + colWidth / 2,
        currentY,
        { align: "center" }
      );

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.text("Nome: ______________________", x + margin, currentY + 18);
      doc.text(
        "Ident.: ____________ OrgÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Emissor: ______",
        x + margin,
        currentY + 32
      );
      doc.text("End.: _________________________", x + margin, currentY + 46);
      doc.text(
        "Cidade: _____________________ UF: _____",
        x + margin,
        currentY + 60
      );
      doc.text("Telefone: ____________", x + margin, currentY + 74);

      doc.setDrawColor(200, 200, 200);
      doc.line(
        x + margin + colWidth + 10,
        currentY,
        x + margin + colWidth + 10,
        currentY + 85
      );

      const rightColX = x + margin + colWidth + 20;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text(
        "IDENTIFICAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO DO FORNECEDOR",
        rightColX + colWidth / 2,
        currentY,
        { align: "center" }
      );

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.text("Assinatura do FarmacÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªutico:", rightColX, currentY + 18);

      doc.setDrawColor(0, 0, 0);
      doc.line(rightColX, currentY + 22, rightColX + colWidth, currentY + 22);
      doc.text("Data: ____/____/_____", rightColX, currentY + 40);

      addFooter(x, pageHeight - footerHeight + 35);
    };

    // Duas vias
    await drawContent(0, 0);
    await drawContent(halfWidth, 0);

    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(1);
    doc.line(halfWidth, 0, halfWidth, pageHeight);

    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Criar iframe para impressÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o automÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡tica
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    iframe.onload = function () {
      setTimeout(function () {
        iframe.contentWindow?.print();
      }, 500);
    };

    return pdfBlob;
  };

  const handleGenerateOftalmoPDF = async (item: ReceituarioLaudo) => {
    const agora = new Date();
    const dataHoraAtual = agora.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });
    const marginLeft = 40;
    const marginRight = 40;
    const marginTop = 20;
    const pageWidth =
      doc.internal.pageSize.getWidth() - marginLeft - marginRight;
    const pageHeight = doc.internal.pageSize.getHeight();
    const centerX = doc.internal.pageSize.getWidth() / 2;
    let currentY = marginTop;

    const addFooter = () => {
      const additionalInfo = [
        "Rua: Coralio Soares de Oliveira, nÃ‚Âº 497, Centro, Joao Pessoa - PB, CEP 58.013-260.",
        "Telefone: 3533-5310 - www.afrafepsaude.com.br  @afrafepsaude",
        "CNPJ: 09.306.242/0001-82.",
      ];

      doc.setTextColor(105, 105, 105);
      let yOffset = pageHeight - 80;

      additionalInfo.forEach((line) => {
        const splitText = doc.splitTextToSize(line, 300);
        splitText.forEach((textLine: any) => {
          doc.text(textLine, 25, yOffset);
          yOffset += 10;
        });
        yOffset += 5;
      });

      const imgWidth = 180;
      const imgHeight = 80;
      const xOffsetImage = doc.internal.pageSize.width - imgWidth - 40;
      const yOffsetImage = pageHeight - imgHeight - 17;
      doc.addImage(
        rodape,
        "PNG",
        xOffsetImage,
        yOffsetImage,
        imgWidth,
        imgHeight
      );
    };

    const addHeader = async () => {
      const logoImg = new Image();
      logoImg.src = Logo;
      await new Promise<void>((resolve) => {
        logoImg.onload = () => {
          const imgWidth = doc.internal.pageSize.getWidth();
          const imgHeight = (logoImg.height * imgWidth) / logoImg.width;
          doc.addImage(Logo, "PNG", 0, 0, imgWidth, imgHeight);
          currentY = imgHeight + 30;
          resolve();
        };
        logoImg.onerror = (err) => {
          console.error("Erro ao carregar o logo:", err);
          resolve();
        };
      });
    };

    const addWatermark = async () => {
      await new Promise<void>((resolve) => {
        const watermarkImg = new Image();
        watermarkImg.src = WatermarkLogo;
        watermarkImg.onload = () => {
          const watermarkWidth = 350;
          const watermarkHeight =
            (watermarkImg.height * watermarkWidth) / watermarkImg.width;

          const canvas = document.createElement("canvas");
          canvas.width = watermarkImg.width;
          canvas.height = watermarkImg.height;
          const ctx = canvas.getContext("2d");

          if (ctx) {
            ctx.drawImage(watermarkImg, 0, 0);
            const imageData = ctx.getImageData(
              0,
              0,
              canvas.width,
              canvas.height
            );
            const data = imageData.data;

            for (let i = 0; i < data.length; i += 4) {
              if (data[i] > 150 && data[i + 1] < 80 && data[i + 2] < 80) {
                data[i] = 36;
                data[i + 1] = 99;
                data[i + 2] = 235;
                data[i + 3] = 30;
              } else if (data[i + 3] > 0) {
                data[i + 3] = 30;
              }
            }
            ctx.putImageData(imageData, 0, 0);

            doc.addImage(
              canvas.toDataURL("image/png"),
              "PNG",
              centerX - watermarkWidth / 2,
              pageHeight / 2 - watermarkHeight / 2,
              watermarkWidth,
              watermarkHeight,
              undefined,
              "FAST"
            );
          }
          resolve();
        };
        watermarkImg.onerror = (err) => {
          console.error("Erro ao carregar a imagem da marca d'ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡gua:", err);
          resolve();
        };
      });
    };

    // FunÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o para formatar valores ou retornar "-" se vazio
    const formatValue = (value: any) => value || "-";

    // FunÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o para adicionar conteÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºdo principal do PDF
    const addContent = async () => {
      await addWatermark();
      await addHeader();

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      doc.text(`Nome: ${item.paciente.nmPaciente}`, marginLeft, currentY);
      currentY += 20;

      // Imagens de OD e OE
      const protractorWidth = 250;
      const protractorHeight = 150;
      const protractorX1 = marginLeft + 10;
      const protractorX2 = centerX + 10;
      const protractorY = currentY;

      doc.addImage(
        odPng,
        "PNG",
        protractorX1,
        protractorY,
        protractorWidth,
        protractorHeight
      );
      doc.addImage(
        oePng,
        "PNG",
        protractorX2,
        protractorY,
        protractorWidth,
        protractorHeight
      );

      currentY += protractorHeight + 30;

      // Tabelas LONGE e PERTO usando os nomes de campos corretos
      const tablesData = [
        {
          title: "LONGE",
          data: {
            od: {
              esf: item.odEsfLong,
              cil: item.odCilLong,
              eixo: item.odEixoLong,
              prisma: item.odPrismaLong,
              base: item.odBaseLong,
            },
            oe: {
              esf: item.oeEsfLong,
              cil: item.oeCilLong,
              eixo: item.oeEixoLong,
              prisma: item.oePrismaLong,
              base: item.oeBaseLong,
            },
          },
        },
        {
          title: "PERTO",
          data: {
            od: {
              esf: item.odEsfPerto,
              cil: item.odCilPerto,
              eixo: item.odEixoPerto,
              prisma: item.odPrismaPerto,
              base: item.odBasePerto,
            },
            oe: {
              esf: item.oeEsfPerto,
              cil: item.oeCilPerto,
              eixo: item.oeEixoPerto,
              prisma: item.oePrismaPerto,
              base: item.oeBasePerto,
            },
          },
        },
      ];

      for (const table of tablesData) {
        // Verificar se hÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ dados para esta tabela
        const hasData =
          table.data.od.esf ||
          table.data.od.cil ||
          table.data.od.eixo ||
          table.data.od.prisma ||
          table.data.od.base ||
          table.data.oe.esf ||
          table.data.oe.cil ||
          table.data.oe.eixo ||
          table.data.oe.prisma ||
          table.data.oe.base;

        if (hasData) {
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text(table.title, marginLeft, currentY);
          currentY += 20;

          const bodyData = [
            [
              "OD",
              formatValue(table.data.od.esf),
              formatValue(table.data.od.cil),
              formatValue(table.data.od.eixo),
              formatValue(table.data.od.prisma),
              formatValue(table.data.od.base),
            ],
            [
              "OE",
              formatValue(table.data.oe.esf),
              formatValue(table.data.oe.cil),
              formatValue(table.data.oe.eixo),
              formatValue(table.data.oe.prisma),
              formatValue(table.data.oe.base),
            ],
          ];

          autoTable(doc, {
            head: [["Olho", "Esf.", "Cil.", "Eixo", "Prisma", "Base"]],
            body: bodyData,
            startY: currentY,
            theme: "grid",
            headStyles: {
              fillColor: [66, 139, 202],
              textColor: [255, 255, 255],
              fontStyle: "bold",
            },
            margin: { left: marginLeft, right: marginRight },
            styles: { fontSize: 10, halign: "center" },
            columnStyles: { 0: { cellWidth: "auto" } },
          });

          currentY = (doc as any).lastAutoTable.finalY + 20;
        }
      }

      // ObservaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âµes
      if (item.prescricao) {
        if (currentY > pageHeight - 80) {
          doc.addPage();
          currentY = marginTop + 40;
        }
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text("OBS:", marginLeft, currentY);
        doc.setFont("helvetica", "normal");
        currentY += 15;
        const splitObs = doc.splitTextToSize(item.prescricao, pageWidth);
        doc.text(splitObs, marginLeft, currentY);
        currentY += splitObs.length * 15 + 20;
      }

      if (currentY > pageHeight - 100) {
        doc.addPage();
        currentY = marginTop + 40;
      }

      // Assinatura
      doc.setFontSize(10);

      // Linha para assinatura (centralizada)
      const signatureLineWidth = 200;
      const signatureLineX = centerX - signatureLineWidth / 2;

      doc.line(
        signatureLineX,
        currentY + 60,
        signatureLineX + signatureLineWidth,
        currentY + 60
      );

      // Texto "Carimbo e Assinatura do MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©dico" centralizado
      doc.text("Carimbo e Assinatura do MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©dico", centerX, currentY + 75, {
        align: "center",
      });

      // Nome do profissional centralizado
      doc.text(`${item.profissional.nmProfissional}`, centerX, currentY + 90, {
        align: "center",
      });

      // Data e hora de emissÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o alinhada ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â  direita
      doc.text(
        `Data e hora de emissÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o: ${dataHoraAtual}`,
        doc.internal.pageSize.getWidth() - marginRight,
        currentY + 20,
        { align: "right" }
      );
      addFooter();
    };

    // 1ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª via
    currentY = marginTop;
    await addContent();

    // NumeraÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o das pÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ginas
    const totalPages = (doc as any).internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(100);
      doc.text(`Pagina ${i} de ${totalPages}`, centerX, pageHeight - 20, {
        align: "center",
      });
    }

    // Gerar PDF e abrir diÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡logo de impressÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o diretamente
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Criar iframe para impressÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o automÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡tica
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    iframe.onload = function () {
      setTimeout(function () {
        iframe.contentWindow?.print();
      }, 500);
    };

    return pdfBlob;
  };

  // Esta funÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o precisa ser implementada ou removida se nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o for usada
  const visualizarReceituarioLaudo = (item: ReceituarioLaudo) => {
    // FunÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o para converter HTML em texto formatado COM ESPAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?AMENTO REDUZIDO
    const htmlToFormattedText = (html: string): string => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;

      const processNode = (node: Node): string => {
        if (node.nodeType === Node.TEXT_NODE) {
          return node.textContent?.replace(/\s+/g, " ") || "";
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          const element = node as HTMLElement;

          switch (element.tagName.toLowerCase()) {
            case "p":
              return (
                Array.from(element.childNodes).map(processNode).join("") + "\n"
              );
            case "br":
              return "\n";
            case "div":
              return (
                Array.from(element.childNodes).map(processNode).join("") + "\n"
              );
            case "strong":
            case "b":
              return Array.from(element.childNodes).map(processNode).join("");
            case "em":
            case "i":
              return Array.from(element.childNodes).map(processNode).join("");
            case "ul":
              return Array.from(element.children)
                .map((li) => "ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ " + processNode(li) + "\n")
                .join("");
            case "ol":
              return Array.from(element.children)
                .map((li, index) => index + 1 + ". " + processNode(li) + "\n")
                .join("");
            case "li":
              return Array.from(element.childNodes)
                .map(processNode)
                .join("")
                .trim();
            default:
              return Array.from(element.childNodes).map(processNode).join("");
          }
        }
        return "";
      };

      let result = Array.from(tempDiv.childNodes).map(processNode).join("");

      // Reduz mÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºltiplas quebras de linha consecutivas
      result = result
        .replace(/\n\s*\n/g, "\n")
        .replace(/\n{3,}/g, "\n\n")
        .replace(/[ \t]+/g, " ")
        .trim();

      return result;
    };

    // FunÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o auxiliar para formatar datas
    const formatDate = (dateString: string) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("pt-BR");
    };

    // FunÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o para converter nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºmeros em dias por extenso
    const diasPorExtenso = (dias: number) => {
      if (dias === 0) return "zero";
      const unidades = [
        "",
        "um",
        "dois",
        "trÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªs",
        "quatro",
        "cinco",
        "seis",
        "sete",
        "oito",
        "nove",
      ];
      const dezenas = [
        "",
        "dez",
        "vinte",
        "trinta",
        "quarenta",
        "cinquenta",
        "sessenta",
        "setenta",
        "oitenta",
        "noventa",
      ];
      const especiais = [
        "dez",
        "onze",
        "doze",
        "treze",
        "quatorze",
        "quinze",
        "dezesseis",
        "dezessete",
        "dezoito",
        "dezenove",
      ];

      if (dias < 10) return unidades[dias];
      if (dias < 20) return especiais[dias - 10];
      if (dias < 100) {
        const dezena = Math.floor(dias / 10);
        const unidade = dias % 10;
        return dezenas[dezena] + (unidade > 0 ? " e " + unidades[unidade] : "");
      }
      return dias.toString();
    };

    // FunÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o para formatar o conteÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºdo do atestado (versÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o compacta)
    const formatAtestadoContent = (item: ReceituarioLaudo) => {
      const diasAfastamento = item.atestadoQtdDias || 0;
      const diasEscritoAfastamento = diasPorExtenso(diasAfastamento);
      const dataAtestado =
        formatDate(item.dtConsulta) || new Date().toLocaleDateString("pt-BR");

      return `
      <div style="margin-bottom: 8px; font-size: 11px; line-height: 1.4; text-align: justify;">
        <p>
          Atesto, para os devidos fins, a pedido do interessado, que o Sr.(a) ${
            item.paciente.nmPaciente
          }, 
          portador do CPF: ${
            item.paciente.nuCpf
          } foi submetido ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â  consulta nesta data, no horÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rio das 
          ${
            item.hrConsulta || "nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"
          }, sendo portador de afecÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o CID-${item.cid || "nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"}.
        </p>
        
        <p style="margin-top: 8px;">
          Em decorrÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia deverÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ permanecer afastado de suas atividades laborativas por um perÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­odo de 
          ${diasAfastamento} (${diasEscritoAfastamento}) dia(s) a partir desta data. JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa, ${dataAtestado}.
        </p>
      </div>
      
      <div style="margin: 15px 0; text-align: center; font-size: 10px;">
        <div style="border-top: 1px solid #000; width: 60%; margin: 0 auto; padding-top: 3px;"></div>
        <p style="font-weight: 600; margin-top: 4px;">Dr. ${
          item.profissional.nmProfissional
        }</p>     
      </div>
      
      <div style="margin-top: 15px; text-align: center; font-size: 10px;">
        <h4 style="color: #2463EB; font-size: 12px; margin-bottom: 8px;">AutorizaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o</h4>
        <p style="text-align: justify; line-height: 1.4;">
          Eu, ${item.paciente.nmPaciente}, autorizo o Dr. ${
        item.profissional.nmProfissional
      } 
          a registrar o diagnÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³stico (codificado - CID: ${
            item.cid || "nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"
          } ou por extenso) neste atestado.
        </p>
        
        <div style="margin: 15px 0; text-align: center;">
          <div style="border-top: 1px solid #000; width: 60%; margin: 0 auto; padding-top: 3px;"></div>
          <p style="margin-top: 4px;">Assinatura do UsuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rio - RG</p>
        </div>
      </div>
    `;
    };

    // FunÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o para formatar o conteÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºdo do receituario/laudo (versÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o compacta) com informaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âµes do paciente
    const formatPrescricaoContent = (item: ReceituarioLaudo, tipo: string) => {
      return `
  <div style="margin-bottom: 8px; font-size: 11px; line-height: 1.4;">
    <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 6px;">
      ${tipo === "RECEITA" ? "PrescriÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o:" : ""}
    </h4>
    
    <!-- InformaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âµes do paciente -->
    <div style="margin-bottom: 1px; padding: 8px; text-align: justify">
      <p style="margin: 2px 0; font-size: 12px;">
        <strong>Paciente:</strong> ${item.paciente.nmPaciente}
      </p> 
    </div>
    
    <div style="text-align: justify; white-space: pre-wrap;">
      ${htmlToFormattedText(item.prescricao)}
    </div>
  </div>
  
  <div style="margin: 15px 0; text-align: center; font-size: 10px;">
    <div style="border-top: 1px solid #000; width: 60%; margin: 0 auto; padding-top: 3px;"></div>
    <p style="font-weight: 600; margin-top: 4px;">Dr. ${
      item.profissional.nmProfissional
    }</p>     
  </div>
`;
    };

    // FunÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o para formatar o conteÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºdo do receituario/laudo (versÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o compacta)
    const formatPrescricaofISIOContent = (
      item: ReceituarioLaudo,
      tipo: string
    ) => {
      return `
      <div style="margin-bottom: 8px; font-size: 11px; line-height: 1.4;">
        <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 6px;">
          ${tipo === "RECEITA" ? "PrescriÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o:" : ""}
        </h4>
        <div style="text-align: justify; white-space: pre-wrap;">
          <p style="margin: 2px 0; font-size: 12px;">
        <strong>Paciente:</strong> ${item.paciente.nmPaciente}
      </p>   </div>
        <div style="text-align: justify; white-space: pre-wrap;">
          ${htmlToFormattedText(item.prescricao)}
        </div>
      </div>
      
      <div style="margin: 15px 0; text-align: center; font-size: 10px;">
        <div style="border-top: 1px solid #000; width: 60%; margin: 0 auto; padding-top: 3px;"></div>
        <p style="font-weight: 600; margin-top: 4px;">Dr. ${
          item.profissional.nmProfissional
        }</p>     
      </div>
    `;
    };

    // FunÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o para formatar o conteÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºdo do receituario especial (versÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o compacta)
    const formatReceituarioEspecialContent = (item: ReceituarioLaudo) => {
      const enderecoPaciente = item.paciente.nuEndereco || "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado";
      const CRM = Cookies.get("CRM") || "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado";

      return `
      <div style="margin-bottom: 8px; text-align: left; font-size: 11px; line-height: 1.4;">
        <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 6px;">IDENTIFICAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO DO EMITENTE</h4>
        <p><strong>Nome completo:</strong> Dr. ${
          item.profissional.nmProfissional
        }</p>
        <p><strong>CNPJ:</strong> 09.306.242/0001-82</p>
        <p><strong>EndereÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§o completo e Telefone:</strong> Rua CorÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡lio Soares de Oliveira ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?" 497, Centro (83) 3533.5310</p>
        <p><strong>Cidade:</strong> JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa</p>
        <p><strong>UF:</strong> ParaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­ba</p>
      </div>

      <hr style="margin: 8px 0; border: 0; border-top: 1px solid #ccc;">

      <div style="margin-bottom: 8px; text-align: left; font-size: 11px; line-height: 1.4;">
        <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 6px;">INFORMAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½.ES DO PACIENTE</h4>
        <p><strong>Paciente:</strong> ${item.paciente.nmPaciente}</p>
        <p><strong>EndereÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§o:</strong> ${enderecoPaciente}</p>
      </div>

      <hr style="margin: 8px 0; border: 0; border-top: 1px solid #ccc;">

      <div style="margin-bottom: 8px; font-size: 11px;">
        <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 6px;">PRESCRIÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?DICA</h4>
        <div style="text-align: justify; line-height: 1.4; white-space: pre-wrap;">
          ${htmlToFormattedText(item.prescricao)}
        </div>
      </div>

      <div style="margin: 15px 0; text-align: center; font-size: 10px;">
        <div style="border-top: 1px solid #000; width: 60%; margin: 0 auto;"></div>
        <p style="font-weight: 600; margin-top: 4px;">CARIMBO E ASSINATURA DO MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?DICO</p>
        <p style="font-weight: 500; margin-top: 2px; font-size: 9px;">CRM: ${CRM}</p>
        <p style="margin-top: 10px; text-align: left; font-size: 10px;"><strong>Data:</strong> ${
          formatDate(item.dtConsulta) || new Date().toLocaleDateString("pt-BR")
        }</p>
      </div>

      <div style="display: flex; justify-content: space-between; margin-top: 15px; font-size: 10px;">
        <div style="width: 48%; text-align: left;">
          <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 4px; border-bottom: 1px solid #ddd; padding-bottom: 3px;">
            IDENTIFICAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO DO COMPRADOR
          </h4>
          <p style="margin: 4px 0;"><strong>Nome:</strong> __________________________________</p>
          <p style="margin: 4px 0;"><strong>Ident.:</strong> ___________________ <strong>OrgÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Emissor:</strong> ______</p>
          <p style="margin: 4px 0;"><strong>End.:</strong> _________________________</p>
          <p style="margin: 4px 0;"><strong>Cidade:</strong> __________________________ <strong>UF:</strong> _____</p>
          <p style="margin: 4px 0;"><strong>Telefone:</strong> _________________</p>
        </div>

        <div style="width: 48%;">
          <h4 style="color: #000; font-weight: 600; font-size: 12px; text-align: center; margin-bottom: 4px;">IDENTIFICAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO DO FORNECEDOR</h4>
          <p>Assinatura do FarmacÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªutico: _______________________________</p>
          <p>Data: _____/______/__________</p>
        </div>
      </div>
    `;
    };

    // FunÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o para formatar o conteÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºdo do receituario oftalmolÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³gico
    const formatOftalmoContent = (item: ReceituarioLaudo) => {
      // Verificar se hÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ dados oftalmolÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³gicos
      const hasOftalmoData =
        item.odEsfLong ||
        item.odCilLong ||
        item.odEixoLong ||
        item.odPrismaLong ||
        item.odBaseLong ||
        item.oeEsfLong ||
        item.oeCilLong ||
        item.oeEixoLong ||
        item.oePrismaLong ||
        item.oeBaseLong ||
        item.odEsfPerto ||
        item.odCilPerto ||
        item.odEixoPerto ||
        item.odPrismaPerto ||
        item.odBasePerto ||
        item.oeEsfPerto ||
        item.oeCilPerto ||
        item.oeEixoPerto ||
        item.oePrismaPerto ||
        item.oeBasePerto;

      if (!hasOftalmoData) {
        return `
      <div style="text-align: center; padding: 20px; color: #666;">
        <p>Nenhum dado oftalmolÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³gico encontrado para este receituario.</p>
      </div>
    `;
      }

      // FunÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o para formatar os valores ou retornar "-" se vazio
      const formatValue = (value: any) => value || "-";

      return `
    <div style="margin-bottom: 15px;">
      <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
        <div style="width: 48%; text-align: center;">
          <img src="/od.svg" alt="Olho Direito" style="width: 600px; height: 200px; margin-bottom: 10px;">
          <p style="font-weight: bold;">OD - Olho Direito</p>
        </div>
        <div style="width: 48%; text-align: center;">
          <img src="/oe.svg" alt="Olho Esquerdo" style="width: 600px; height: 200px; margin-bottom: 10px;">
          <p style="font-weight: bold;">OE - Olho Esquerdo</p>
        </div>
      </div>

      ${
        item.odEsfLong ||
        item.odCilLong ||
        item.odEixoLong ||
        item.odPrismaLong ||
        item.odBaseLong ||
        item.oeEsfLong ||
        item.oeCilLong ||
        item.oeEixoLong ||
        item.oePrismaLong ||
        item.oeBaseLong
          ? `
      <div style="margin-bottom: 15px;">
        <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 8px; border-bottom: 1px solid #ddd; padding-bottom: 3px;">LONGE</h4>
        <table style="width: 100%; border-collapse: collapse; font-size: 11px;">
          <thead>
            <tr style="background-color: #f2f2f2;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Olho</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Esf.</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Cil.</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Eixo</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Prisma</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Base</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center; font-weight: bold;">OD</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odEsfLong
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odCilLong
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odEixoLong
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odPrismaLong
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odBaseLong
              )}</td>
            </tr>
            <tr>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center; font-weight: bold;">OE</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oeEsfLong
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oeCilLong
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oeEixoLong
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oePrismaLong
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oeBaseLong
              )}</td>
            </tr>
          </tbody>
        </table>
      </div>
      `
          : ""
      }

      ${
        item.odEsfPerto ||
        item.odCilPerto ||
        item.odEixoPerto ||
        item.odPrismaPerto ||
        item.odBasePerto ||
        item.oeEsfPerto ||
        item.oeCilPerto ||
        item.oeEixoPerto ||
        item.oePrismaPerto ||
        item.oeBasePerto
          ? `
      <div style="margin-bottom: 15px;">
        <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 8px; border-bottom: 1px solid #ddd; padding-bottom: 3px;">PERTO</h4>
        <table style="width: 100%; border-collapse: collapse; font-size: 11px;">
          <thead>
            <tr style="background-color: #f2f2f2;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Olho</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Esf.</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Cil.</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Eixo</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Prisma</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Base</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center; font-weight: bold;">OD</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odEsfPerto
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odCilPerto
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odEixoPerto
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odPrismaPerto
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odBasePerto
              )}</td>
            </tr>
            <tr>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center; font-weight: bold;">OE</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oeEsfPerto
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oeCilPerto
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oeEixoPerto
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oePrismaPerto
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oeBasePerto
              )}</td>
            </tr>
          </tbody>
        </table>
      </div>
      `
          : ""
      }

      ${
        item.prescricao
          ? `
      <div style="margin-bottom: 15px;">
        <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 8px;">OBSERVAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½.ES</h4>
        <div style="text-align: justify; white-space: pre-wrap; font-size: 11px; line-height: 1.4;">
          ${htmlToFormattedText(item.prescricao)}
        </div>
      </div>
      `
          : ""
      }
    </div>

    <div style="margin: 15px 0; text-align: center; font-size: 10px;">
      <div style="border-top: 1px solid #000; width: 60%; margin: 0 auto; padding-top: 3px;"></div>
      <p style="font-weight: 600; margin-top: 4px;">Dr. ${
        item.profissional.nmProfissional
      }</p>
    </div>
  `;
    };

    // Determina o conteÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºdo baseado no tipo
    let content = "";
    let title = "";

    switch (item.tipo) {
      case "ATESTADO":
        title = "ATESTADO MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?DICO";
        content = formatAtestadoContent(item);
        break;
      case "LAUDO":
        title = "LAUDO";
        content = formatPrescricaoContent(item, "LAUDO");
        break;
      case "RECEITA":
        title = "RECEITUARIO COMUM";
        content = formatPrescricaoContent(item, "RECEITA");
        break;
      case "RECEITA_ESPECIAL":
        title = "RECEITUARIO ESPECIAL";
        content = formatReceituarioEspecialContent(item);
        break;
      case "OFTALMO":
        title = "OFTALMOLOGICO";
        content = formatOftalmoContent(item);
        break;
      case "ALTA_FISIO":
        title = "ALTA FISIOTERAPIA";
        content = formatPrescricaofISIOContent(item, "ALTA_FISIO");
        break;
      default:
        title = item.tipo.replace(/_/g, " ");
        content = htmlToFormattedText(item.prescricao);
    }

    // Determina a funÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o de geraÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o de PDF
    const generatePDF = () => {
      switch (item.tipo) {
        case "ATESTADO":
          handleGenerateAtestadoPDF(item);
          break;
        case "LAUDO":
          handleGenerateLaudoPDF(item);
          break;
        case "RECEITA":
          handleGenerateReceituarioPDF(item);
          break;
        case "RECEITA_ESPECIAL":
          handleGenerateReceituarioEspecialPDF(item);
          break;
        case "OFTALMO":
          handleGenerateOftalmoPDF(item);
          break;
        case "ALTA_FISIO":
          handleGenerateAltaFisioPDF(item);
          break;
        default:
          break;
      }
    };

    // Cria a visualizaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o com o mesmo design dos PDFs
    Swal.fire({
      title: `<div style="color: #2463EB; font-size: 15px; font-weight: bold; margin-bottom: 10px;">
      <img src="${Logo}" alt="Logo" style="width: 100%; max-width: 800px; height: auto; margin: 0 auto;">
      <p style="color: #2463EB; font-size: 12px; margin-top: 10px;">
        AssociaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o dos Auditores Fiscais do Estado da ParaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­ba
      </p>
      ${title}
    </div>`,
      html: `
      <div style="max-width: 800px; margin: 0 auto; font-family: Arial, sans-serif; color: #333;">
        <div style="text-align: center; margin-bottom: 10px;">
          ${
            item.tipo === "RECEITA_ESPECIAL"
              ? `
            <div style="text-align: right; font-size: 10px; margin-top: 5px;">
              <p>1ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª Via - RetenÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o da FarmÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡cia ou Drogaria</p>
              <p>2ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª Via - OrientaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o ao Paciente</p>
            </div>
          `
              : ""
          }
        </div>
        
        <div style="background-color: white; padding: 20px; border-radius: 5px;">
          ${content}
        </div>
        
        <div style="margin-top: 30px; font-size: 9px; display: flex; justify-content: space-between;">
          <div style="width: 48%; color: #2463EB;">
            <p>Rua CorÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡lio Soares de Oliveira, 497 ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ Centro, JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ PB</p>
            <p>Fone: (83) 3533.5310 | 3533.5311</p>
            <p>www.afrafep.org.br</p>
            <p>INSC. ANS NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â° 330281</p>
          </div>
          
          <div style="width: 48%; text-align: right; color: #2463EB;">
            <p>ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?tica e TransparÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia</p>
            <p>Solidariedade e Responsabilidade Social</p>
            <p>Comprometimento e Profissionalismo</p>
            <p>Legalidade e Respeito</p>
          </div>
        </div>
      </div>
    `,
      width: "850px",
      showCloseButton: true,
      showConfirmButton: false,
      footer: `
      <button id="print-pdf-btn" style="
        background-color: #2463EB;
        color: white;
        border: none;
        padding: 10px 20px;
        border-radius: 4px;
        cursor: pointer;
        font-weight: bold;
        font-size: 14px;
      ">
        <i class="fas fa-print"></i> Imprimir Documento
      </button>
    `,
      didOpen: () => {
        const printBtn = document.getElementById("print-pdf-btn");
        if (printBtn) {
          printBtn.addEventListener("click", generatePDF);
        }
      },
    });
  };

  return (
    <>
      <Menu
        onSelectMenu={function (path: string): void {
          throw new Error("Function not implemented.");
        }}
      />
      <div className="p-2 sm:p-3 md:p-4 bg-gradient-to-tr from-gray-50 to-gray-100 min-h-[85vh] space-y-4 sm:space-y-3">
        {/* Menu Superior - MAIS COMPACTO */}
        <div className="flex flex-col lg:flex-row lg:items-center p-3 rounded-xl border border-gray-200 gap-3 bg-white shadow-sm">
          {/* Lado esquerdo: filtros, status e outros botÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âµes */}
          <div className="flex flex-wrap gap-2 sm:gap-3 items-center">
            {flPms !== "1" && flPms !== "0" ? (
              <button
                onClick={() => {
                  window.location.assign("/Record");
                }}
                className="bg-gray-800 hover:bg-gray-700 text-white font-semibold py-1.5 px-3 rounded text-xs sm:text-sm"
              >
                Atualizar
              </button>
            ) : (
              <button
                onClick={atualizarAgenda}
                className="flex items-center gap-1 bg-gray-600 hover:bg-gray-800 text-white px-3 py-1.5 rounded-lg shadow transition text-xs sm:text-sm"
              >
                Atualizar
              </button>
            )}

            {flPms === "1" && (
              <button
                onClick={() => setIsOpen(true)}
                className="bg-gray-200 hover:bg-gray-300 px-3 py-1.5 rounded-lg transition text-xs sm:text-sm"
              >
                {"Status + sa\u00FAde"}
              </button>
            )}

            <DocumentosHandler especialidadeAtual={especialidadeAtual} />
          </div>

          {/* BotÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Voltar sempre ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â  direita */}
          <div className="ml-auto mt-2 lg:mt-0">
            <button
              onClick={() => navigate("/Sad_Formulario")}
              className="bg-red-600 hover:bg-red-500 text-white font-semibold py-1.5 px-3 rounded text-xs sm:text-sm"
            >
              Voltar
            </button>
          </div>
        </div>

        {/* TÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­tulo Principal - FONTE MENOR */}
        <h1 className="text-lg sm:text-xl font-bold text-gray-800 text-center sm:text-left flex items-center gap-2">
          <Stethoscope className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" />
          Paciente:{" "}
          {nome
            ? nome
                .toLowerCase()
                .split(" ")
                .map((p: any) => p.charAt(0).toUpperCase() + p.slice(1))
                .join(" ")
            : ""}{" "}
          - idade {idade}
        </h1>

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          toastClassName={() =>
            "bg-black text-white font-semibold rounded shadow-md p-2 text-xs"
          }
          progressClassName="bg-red-500"
        />

        {/* Conteudo Principal - LAYOUT MAIS COMPACTO */}
        <div className="flex flex-col lg:flex-row gap-4 sm:gap-6">
          {/* Anamnese - MAIS COMPACTA */}
          <div className="w-full lg:w-2/3 bg-white p-3 sm:p-4 md:p-6 rounded-xl sm:rounded-2xl shadow-lg border border-gray-100">
            <h2 className="flex items-center justify-between text-lg sm:text-xl font-semibold text-gray-500 mb-3">
              <div className="flex items-center gap-2">
                <NotebookPen className="w-4 h-4 sm:w-5 sm:h-5 text-green-600" />
                {"Prontu\u00E1rio"}
              </div>
              <ProntuarioAnexos
                variant="button"
                prontuarioId={prontuarioAtualId}
                refreshKey={anexosRefreshKey}
                onUploadSuccess={() =>
                  setAnexosRefreshKey((prev) => prev + 1)
                }
              />
            </h2>
            {modalAberto && (
              <ModalVisualizacao
                activeTab={activeTab}
                modalAberto={modalAberto}
                setModalAberto={setModalAberto}
                prontuarioAtual={prontuarioAtual}
                evolucaoEditando={evolucaoEditando}
                loadingMeus={loadingMeus}
                meusAtendimentos={meusAtendimentos}
                paginaAtual={paginaAtual}
                itensPorPagina={itensPorPagina}
                totalPaginas={totalPaginas}
                mudarPagina={mudarPagina}
                prontuarioIndexAberto={prontuarioIndexAberto}
                setProntuarioIndexAberto={setProntuarioIndexAberto}
              />
            )}

            <>
              {/* Exibe o editor ReactQuill se showButtons for true */}
              <ReactQuill
                onChange={handleChange}
                modules={{
                  toolbar: [
                    [{ font: [] }],
                    [{ size: ["small", "medium", "large", "huge"] }],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["bold", "italic", "underline"],
                    ["link", "image"],
                    [{ align: [] }],
                    [
                      {
                        color: ["#000000", "#e60000", "#0000ff", "#808080"],
                      },
                      { background: ["#ffff00"] },
                    ],
                    ["blockquote"],
                  ],
                }}
                style={{ height: "18rem", marginBottom: "2.5rem" }}
              />

              {/* Contagem de caracteres visivel apenas durante a edicao */}
              <p className="text-xs sm:text-sm text-gray-500 break-words">
                {(prontuarioAtual || "").length}/{LIMITE_CARACTERES} caracteres
              </p>
            </>

            <div className="mt-4 flex flex-wrap gap-3">
              <button
                className="flex items-center gap-2 bg-blue-100 hover:bg-blue-200 text-blue-900 px-4 py-2 rounded-lg transition shadow w-full sm:w-auto text-xs sm:text-sm"
                onClick={() => setProntuarioAtual("")}
              >
                <FaEraser className="text-xs" />
                {"Limpar Prontu\u00E1rio"}
              </button>

              <button
                className={`${
                  salvando ? "bg-green-400" : "bg-green-600 hover:bg-green-700"
                } text-white px-4 py-2 rounded-lg shadow transition w-full sm:w-auto flex items-center justify-center text-xs sm:text-sm`}
                onClick={salvarProntuario}
                disabled={salvando}
              >
                {salvando ? (
                  <>
                    <FaSave className="animate-spin mr-2 text-xs" /> Salvando...
                  </>
                ) : (
                  <>
                    <FaSave className="mr-2 text-xs" />
                    {modoEdicao ? "Atualizar Prontu\u00E1rio" : "Salvar"}
                  </>
                )}
              </button>
            </div>
          </div>

          {/* Sidebar Direita - MAIS COMPACTA */}
          <div className="w-full lg:w-1/3 space-y-4 sm:space-y-6">
            {/* Meus Atendimentos */}
            <div className="bg-white p-3 sm:p-4 md:p-6 rounded-xl sm:rounded-2xl shadow-lg border border-gray-100">
              <button
                onClick={() => {
                  toggleTab("meus");
                }}
                className="w-full text-left text-sm sm:text-base font-bold text-red-600 border-b border-gray-200 pb-2 mb-3 flex items-center justify-between"
              >
                <span className="flex items-center gap-2 text-xs sm:text-sm">
                  <Stethoscope className="w-3 h-3 sm:w-4 sm:h-4 mr-1" /> Meus
                  Atendimentos
                </span>
                <ChevronRight
                  className={`h-4 w-4 transition-transform duration-300 ${
                    activeTab === "meus" ? "rotate-90" : "rotate-0"
                  }`}
                />
              </button>

              {activeTab === "meus" && (
                <>
                  {loadingMeus ? (
                    <p className="text-xs text-gray-500 italic text-center animate-pulse">
                      Carregando atendimentos...
                    </p>
                  ) : (
                    <>
                      {meusAtendimentos.length > 0 ? (
                        <ul className="list-disc pl-3 space-y-2">
                          {meusAtendimentos
                            .sort(
                              (a, b) =>
                                new Date(b.dtHraEvolucao).getTime() -
                                new Date(a.dtHraEvolucao).getTime()
                            )
                            .slice(0, 10)
                            .map(renderEvolucao)}
                        </ul>
                      ) : (
                        <p className="text-xs text-gray-500 italic text-center">
                          Nenhum atendimento encontrado.
                        </p>
                      )}
                    </>
                  )}
                </>
              )}
            </div>

            {/* Altas - Fisioterapia */}
            <div className="bg-white p-3 sm:p-4 md:p-6 rounded-xl sm:rounded-2xl shadow-lg border border-gray-100">
              <button
                onClick={() => toggleTab("altas")}
                className="w-full text-left text-sm sm:text-base font-bold text-black-600 border-b border-gray-200 pb-2 mb-3 flex items-center justify-between"
              >
                <span className="flex items-center gap-2 text-xs sm:text-sm">
                  <FileText className="w-3 h-3 sm:w-4 sm:h-4 mr-1" /> Altas -
                  Fisioterapia
                </span>
                <ChevronRight
                  className={`h-4 w-4 transition-transform duration-300 ${
                    activeTab === "altas" ? "rotate-90" : "rotate-0"
                  }`}
                />
              </button>
              {activeTab === "altas" && (
                <>
                  {loadingReceituarios ? (
                    <p className="text-xs text-gray-700 italic text-center animate-pulse">
                      Carregando altas...
                    </p>
                  ) : (
                    <>
                      {receituariosLaudos.filter(
                        (item) => item.tipo === "ALTA_FISIO"
                      ).length > 0 ? (
                        <div className="space-y-3">
                          {loadingGruposAltas ? (
                            <p className="text-xs text-gray-500 italic">
                              Carregando altas...
                            </p>
                          ) : (
                            gruposAltas
                              .sort((a, b) =>
                                a.especialidade.localeCompare(
                                  b.especialidade,
                                  "pt-BR"
                                )
                              )
                              .map((grupo) => (
                                <div
                                  key={grupo.especialidade}
                                  className="border rounded-lg p-2"
                                >
                                  <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() =>
                                      toggleEspecialidade(grupo.especialidade)
                                    }
                                  >
                                    <div>
                                      <h4 className="font-bold text-xs text-black-700 uppercase">
                                        {grupo.especialidade}
                                      </h4>
                                    </div>
                                    <span className="text-blue-600 text-lg font-bold">
                                      {expandedEspecialidades.includes(
                                        grupo.especialidade
                                      )
                                        ? "-"
                                        : "+"}
                                    </span>
                                  </div>

                                  {expandedEspecialidades.includes(
                                    grupo.especialidade
                                  ) && (
                                    <div className="mt-2 space-y-3">
                                      {grupo.profissionais
                                        .sort((a, b) =>
                                          a.nome.localeCompare(b.nome, "pt-BR")
                                        )
                                        .map((profissional) => (
                                          <div
                                            key={profissional.idProfissional}
                                            className="ml-3 border-l-2 border-gray-300 pl-2"
                                          >
                                            <div
                                              className="flex justify-between items-center cursor-pointer"
                                              onClick={() =>
                                                toggleProfissional(
                                                  profissional.idProfissional,
                                                )
                                              }
                                            >
                                              <h5 className="font-medium text-xs text-gray-500">
                                                {profissional.nome}
                                              </h5>
                                              <span className="text-blue-600 text-lg font-bold">
                                                {expandedProfissionais.includes(
                                                  profissional.idProfissional
                                                )
                                                  ? "-"
                                                  : "+"}
                                              </span>
                                            </div>

                                            {expandedProfissionais.includes(
                                              profissional.idProfissional
                                            ) && (
                                              <div className="mt-1 space-y-1">
                                                {profissional.items
                                                  .slice(
                                                    ((currentPages[
                                                      profissional
                                                        .idProfissional
                                                    ] || 1) -
                                                      1) *
                                                      itemsPerPage,
                                                    (currentPages[
                                                      profissional
                                                        .idProfissional
                                                    ] || 1) * itemsPerPage
                                                  )
                                                  .map(renderReceituarioLaudo)}

                                                {profissional.items.length >
                                                  itemsPerPage && (
                                                  <div className="flex justify-center items-center mt-2 gap-1">
                                                    <button
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handlePageChange2(
                                                          profissional.idProfissional,
                                                          Math.max(
                                                            (currentPages[
                                                              profissional
                                                                .idProfissional
                                                            ] || 1) - 1,
                                                            1
                                                          )
                                                        );
                                                      }}
                                                      disabled={
                                                        (currentPages[
                                                          profissional
                                                            .idProfissional
                                                        ] || 1) === 1
                                                      }
                                                      className="px-2 py-1 bg-gray-200 rounded text-xs disabled:opacity-50"
                                                    >
                                                      Anterior
                                                    </button>

                                                    <span className="text-xs text-gray-600">
                                                      Pg{" "}
                                                      {currentPages[
                                                        profissional
                                                          .idProfissional
                                                      ] || 1}
                                                    </span>

                                                    <button
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handlePageChange2(
                                                          profissional.idProfissional,
                                                          Math.min(
                                                            (currentPages[
                                                              profissional
                                                                .idProfissional
                                                            ] || 1) + 1,
                                                            Math.ceil(
                                                              profissional.items
                                                                .length /
                                                                itemsPerPage
                                                            )
                                                          )
                                                        );
                                                      }}
                                                      disabled={
                                                        (currentPages[
                                                          profissional
                                                            .idProfissional
                                                        ] || 1) ===
                                                        Math.ceil(
                                                          profissional.items
                                                            .length /
                                                            itemsPerPage
                                                        )
                                                      }
                                                      className="px-2 py-1 bg-gray-200 rounded text-xs disabled:opacity-50"
                                                    >
                                                      {"Pr\u00F3xima"}
                                                    </button>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        ))}
                                    </div>
                                  )}
                                </div>
                              ))
                          )}
                        </div>
                      ) : (
                        <p className="text-xs text-gray-500 italic text-center">
                          Nenhuma alta encontrada.
                        </p>
                      )}
                    </>
                  )}
                </>
              )}
            </div>

            {/* ReceituÃ¡rios, Laudos e Atestados */}
            <div className="bg-white p-3 sm:p-4 md:p-6 rounded-xl sm:rounded-2xl shadow-lg border border-gray-100">
              <button
                onClick={() => toggleTab("receituarios")}
                className="w-full text-left text-sm sm:text-base font-bold text-black-600 border-b border-gray-200 pb-2 mb-3 flex items-center justify-between"
              >
                <span className="flex items-center gap-2 text-xs sm:text-sm">
                  <FileText className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />{" "}
                  {"Receitu\u00E1rios, Laudos e Atestados"}
                </span>
                <ChevronRight
                  className={`h-4 w-4 transition-transform duration-300 ${
                    activeTab === "receituarios" ? "rotate-90" : "rotate-0"
                  }`}
                />
              </button>

              {activeTab === "receituarios" && (
                <>
                  {loadingReceituarios ? (
                    <p className="text-xs text-gray-700 italic text-center animate-pulse">
                      {"Carregando receitu\u00E1rios e laudos..."}
                    </p>
                  ) : (
                    <>
                      {receituariosLaudos.filter(
                        (item) => item.tipo !== "ALTA_FISIO"
                      ).length > 0 ? (
                        <div className="space-y-3">
                          {loadingGrupos ? (
                            <p className="text-xs text-gray-500 italic">
                              Carregando grupos...
                            </p>
                          ) : (
                            grupos
                              .sort((a, b) =>
                                a.especialidade.localeCompare(
                                  b.especialidade,
                                  "pt-BR"
                                )
                              )
                              .map((grupo) => (
                                <div
                                  key={grupo.especialidade}
                                  className="border rounded-lg p-2"
                                >
                                  <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() =>
                                      toggleEspecialidade(grupo.especialidade)
                                    }
                                  >
                                    <div>
                                      <h4 className="font-bold text-xs text-black-700 uppercase">
                                        {grupo.especialidade}
                                      </h4>
                                    </div>
                                    <span className="text-blue-600 text-lg font-bold">
                                      {expandedEspecialidades.includes(
                                        grupo.especialidade
                                      )
                                        ? "-"
                                        : "+"}
                                    </span>
                                  </div>

                                  {expandedEspecialidades.includes(
                                    grupo.especialidade
                                  ) && (
                                    <div className="mt-2 space-y-3">
                                      {grupo.profissionais
                                        .sort((a, b) =>
                                          a.nome.localeCompare(b.nome, "pt-BR")
                                        )
                                        .map((profissional) => (
                                          <div
                                            key={profissional.idProfissional}
                                            className="ml-3 border-l-2 border-gray-300 pl-2"
                                          >
                                            <div
                                              className="flex justify-between items-center cursor-pointer"
                                              onClick={() =>
                                                toggleProfissional(
                                                  profissional.idProfissional
                                                )
                                              }
                                            >
                                              <h5 className="font-medium text-xs text-gray-500">
                                                {profissional.nome}
                                              </h5>
                                              <span className="text-blue-600 text-lg font-bold">
                                                {expandedProfissionais.includes(
                                                  profissional.idProfissional
                                                )
                                                  ? "-"
                                                  : "+"}
                                              </span>
                                            </div>

                                            {expandedProfissionais.includes(
                                              profissional.idProfissional
                                            ) && (
                                              <div className="mt-1 space-y-1">
                                                {profissional.items
                                                  .slice(
                                                    ((currentPages[
                                                      profissional
                                                        .idProfissional
                                                    ] || 1) -
                                                      1) *
                                                      itemsPerPage,
                                                    (currentPages[
                                                      profissional
                                                        .idProfissional
                                                    ] || 1) * itemsPerPage
                                                  )
                                                  .map(renderReceituarioLaudo)}

                                                {profissional.items.length >
                                                  itemsPerPage && (
                                                  <div className="flex justify-center items-center mt-2 gap-1">
                                                    <button
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handlePageChange2(
                                                          profissional.idProfissional,
                                                          Math.max(
                                                            (currentPages[
                                                              profissional
                                                                .idProfissional
                                                            ] || 1) - 1,
                                                            1
                                                          )
                                                        );
                                                      }}
                                                      disabled={
                                                        (currentPages[
                                                          profissional
                                                            .idProfissional
                                                        ] || 1) === 1
                                                      }
                                                      className="px-2 py-1 bg-gray-200 rounded text-xs disabled:opacity-50"
                                                    >
                                                      Anterior
                                                    </button>

                                                    <span className="text-xs text-gray-600">
                                                      Pg{" "}
                                                      {currentPages[
                                                        profissional
                                                          .idProfissional
                                                      ] || 1}
                                                    </span>

                                                    <button
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handlePageChange2(
                                                          profissional.idProfissional,
                                                          Math.min(
                                                            (currentPages[
                                                              profissional
                                                                .idProfissional
                                                            ] || 1) + 1,
                                                            Math.ceil(
                                                              profissional.items
                                                                .length /
                                                                itemsPerPage
                                                            )
                                                          )
                                                        );
                                                      }}
                                                      disabled={
                                                        (currentPages[
                                                          profissional
                                                            .idProfissional
                                                        ] || 1) ===
                                                        Math.ceil(
                                                          profissional.items
                                                            .length /
                                                            itemsPerPage
                                                        )
                                                      }
                                                      className="px-2 py-1 bg-gray-200 rounded text-xs disabled:opacity-50"
                                                    >
                                                      {"Pr\u00F3xima"}
                                                    </button>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        ))}
                                    </div>
                                  )}
                                </div>
                              ))
                          )}
                        </div>
                      ) : (
                        <p className="text-xs text-gray-500 italic text-center">
                          {"Nenhum receitu\u00E1rio ou laudo encontrado."}
                        </p>
                      )}
                    </>
                  )}
                </>
              )}
            </div>

            {/* Guias SADT */}
            <div className="bg-white p-3 sm:p-4 md:p-6 rounded-xl sm:rounded-2xl shadow-lg border border-gray-100">
              <button
                onClick={() => toggleTab("sadt")}
                className="w-full text-left text-sm sm:text-base font-bold text-green-600 border-b border-gray-200 pb-2 mb-3 flex items-center justify-between"
              >
                <span className="flex items-center gap-2 text-xs sm:text-sm">
                  <FaFileMedicalAlt className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />{" "}
                  Guias SADT
                </span>
                <ChevronRight
                  className={`h-4 w-4 transition-transform duration-300 ${
                    activeTab === "sadt" ? "rotate-90" : "rotate-0"
                  }`}
                />
              </button>

              {activeTab === "sadt" && (
                <div className="pt-1">
                  <GuiaSADTSalvas />
                </div>
              )}
            </div>

            <ProntuarioAnexos
              variant="card"
              listMode="cpf"
              prontuarioId={prontuarioAnexosId ?? prontuarioAtualId}
              refreshKey={anexosRefreshKey}
              onUploadSuccess={() => setAnexosRefreshKey((prev) => prev + 1)}
            />

            {/* Outros Profissionais */}
            <div className="bg-white p-3 sm:p-4 md:p-6 rounded-xl sm:rounded-2xl shadow-lg border border-gray-100">
              <button
                onClick={() => toggleTab("outros")}
                className="w-full text-left text-sm sm:text-base font-bold text-blue-600 border-b border-gray-200 pb-2 mb-3 flex items-center justify-between"
              >
                <span className="flex items-center gap-2 text-xs sm:text-sm">
                  <FolderOpen className="w-3 h-3 sm:w-4 sm:h-4 mr-1" /> Outros
                  {"Prontu\u00E1rios"}
                </span>
                <ChevronRight
                  className={`h-4 w-4 transition-transform duration-300 ${
                    activeTab === "outros" ? "rotate-90" : "rotate-0"
                  }`}
                />
              </button>

              {activeTab === "outros" && (
                <>
                  {loadingOutros ? (
                    <p className="text-xs text-gray-500 italic text-center animate-pulse">
                      Carregando profissionais...
                    </p>
                  ) : (
                    <>
                      {outrosProfissionais.length > 0 ? (
                        renderAtendimentos()
                      ) : (
                        <p className="text-xs text-gray-500 italic text-center">
                          Nenhum atendimento por outros profissionais.
                        </p>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AtendimentoPrincipal;

